//第一大项配置
//home配置
//左边一级目录 1  mulu


// #Home 
import Home from "@/views/Home";


//Fengliebiao配置
//左边一级目录 1  mulu
import Fengliebiao from "@/views/Fengliebiao";


//地铁配置
//1.左边一级目录 1  mulu
import Ditie from "@/views/Ditie";


//2.右边地铁线路目录1 mulu1
import yihaoxian from "@/views/Ditie/yihaoxian";
//右边地铁线路目录2
import erhaoxian from "@/views/Ditie/erhaoxian";
//右边地铁线路目录3
import sanhaoxian from "@/views/Ditie/sanhaoxian";
//右边地铁线路目录4
import sihaoxian from "@/views/Ditie/sihaoxian";
//右边地铁线路目录5
import wuhaoxian from "@/views/Ditie/wuhaoxian";
//右边地铁线路目录6
import liuhaoxian from "@/views/Ditie/liuhaoxian";
//右边地铁线路目录6-2，6号线支线
import liuhaoxianzhixian from "@/views/Ditie/liuhaoxianzhixian";
//右边地铁线路目录7
import qihaoxian from "@/views/Ditie/qihaoxian";
//右边地铁线路目录8
import bahaoxian from "@/views/Ditie/bahaoxian";
//右边地铁线路目录9
import jiuhaoxian from "@/views/Ditie/jiuhaoxian";
//右边地铁线路目录10
import shihaoxian from "@/views/Ditie/shihaoxian";
//右边地铁线路目录11
import shiyihaoxian from "@/views/Ditie/shiyihaoxian";
//右边地铁线路目录12
import shierhaoxian from "@/views/Ditie/shierhaoxian";
//右边地铁线路目录14
import shisihaoxian from "@/views/Ditie/shisihaoxian";
//右边地铁线路目录16
import shiliuhaoxian from "@/views/Ditie/shiliuhaoxian";
//右边地铁线路目录20
import ershihaoxian from "@/views/Ditie/ershihaoxian";


//3.深圳地
//1号线站目录 mulu2
import luohu from "@/views/Ditie/yihaoxian/luohu";
import guomao from "@/views/Ditie/yihaoxian/guomao";
import laojie from "@/views/Ditie/yihaoxian/laojie";
import dajuyuan from "@/views/Ditie/yihaoxian/dajuyuan";
import kexueguan from "@/views/Ditie/yihaoxian/kexueguan";
import huaqianglu from "@/views/Ditie/yihaoxian/huaqianglu";
import gangxia from "@/views/Ditie/yihaoxian/gangxia";
import huizhanzhongxin from "@/views/Ditie/yihaoxian/huizhanzhongxin";
import gouwugongyuan from "@/views/Ditie/yihaoxian/gouwugongyuan";
import xiangmihu from "@/views/Ditie/yihaoxian/xiangmihu";
import chegongmiao from "@/views/Ditie/yihaoxian/chegongmiao";
import zhuzilin from "@/views/Ditie/yihaoxian/zhuzilin";
import qiaochengdong from "@/views/Ditie/yihaoxian/qiaochengdong";
import huaqiaocheng from "@/views/Ditie/yihaoxian/huaqiaocheng";
import shijiezhichuang from "@/views/Ditie/yihaoxian/shijiezhichuang";
import baishizhou from "@/views/Ditie/yihaoxian/baishizhou";
import gaoxinyuan from "@/views/Ditie/yihaoxian/gaoxinyuan";
import shenda from "@/views/Ditie/yihaoxian/shenda";
import taoyuan from "@/views/Ditie/yihaoxian/taoyuan";
import daxin from "@/views/Ditie/yihaoxian/daxin";
import liyumen from "@/views/Ditie/yihaoxian/liyumen";
import qianhaiwan from "@/views/Ditie/yihaoxian/qianhaiwan";
import xinan from "@/views/Ditie/yihaoxian/xinan";
import baoanzhongxin from "@/views/Ditie/yihaoxian/baoanzhongxin";
import baoti from "@/views/Ditie/yihaoxian/baoti";
import pingzhou from "@/views/Ditie/yihaoxian/pingzhou";
import xixiang from "@/views/Ditie/yihaoxian/xixiang";
import gushu from "@/views/Ditie/yihaoxian/gushu";
import hourui from "@/views/Ditie/yihaoxian/hourui";
import jichangdong from "@/views/Ditie/yihaoxian/jichangdong";

//2号线站点目录 //站点与x号线交汇，做注释配置
import chiwan from "@/views/Ditie/erhaoxian/chiwan";
import shekougang from "@/views/Ditie/erhaoxian/shekougang";
import haishangshijie from "@/views/Ditie/erhaoxian/haishangshijie";
import shuiwan from "@/views/Ditie/erhaoxian/shuiwan";
import dongjiaotou from "@/views/Ditie/erhaoxian/dongjiaotou";
import wanxia from "@/views/Ditie/erhaoxian/wanxia";
import haiyue from "@/views/Ditie/erhaoxian/haiyue";
import dengliang from "@/views/Ditie/erhaoxian/dengliang";
import houhai from "@/views/Ditie/erhaoxian/houhai";
import keyuan from "@/views/Ditie/erhaoxian/keyuan";
import hongshuwan from "@/views/Ditie/erhaoxian/hongshuwan";
// import shijiezhichuang from "@/views/Ditie/erhaoxian/shijiezhichuang"; //站点与1号线交汇，做注释配置
import qiaochengbei from "@/views/Ditie/erhaoxian/qiaochengbei";
import shenkang from "@/views/Ditie/erhaoxian/shenkang";
import antuoshan from "@/views/Ditie/erhaoxian/antuoshan";
import qiaoxiang from "@/views/Ditie/erhaoxian/qiaoxiang";
import xiangmi from "@/views/Ditie/erhaoxian/xiangmi";
import xiangmeibei from "@/views/Ditie/erhaoxian/xiangmeibei";
import jingtian from "@/views/Ditie/erhaoxian/jingtian";
import lianhuaxi from "@/views/Ditie/erhaoxian/lianhuaxi";
import futian from "@/views/Ditie/erhaoxian/futian";
import shiminzhongxin from "@/views/Ditie/erhaoxian/shiminzhongxin";
import gangxiabei from "@/views/Ditie/erhaoxian/gangxiabei";
import huaqiangbei from "@/views/Ditie/erhaoxian/huaqiangbei";
import yannan from "@/views/Ditie/erhaoxian/yannan";
// import dajuyuan from "@/views/Ditie/erhaoxian/dajuyuan"; //站点与1号线交汇，做注释配置
import hubei from "@/views/Ditie/erhaoxian/hubei";
import huangbeiling from "@/views/Ditie/erhaoxian/huangbeiling";
import xinxiu from "@/views/Ditie/erhaoxian/xinxiu";
import liantangkouan from "@/views/Ditie/erhaoxian/liantangkouan";
import xianhulu from "@/views/Ditie/erhaoxian/xianhulu";
import liantang from "@/views/Ditie/erhaoxian/liantang";

//3号线站点目录 //站点与x号线交汇，做注释配置
import fubao from "@/views/Ditie/sanhaoxian/fubao";
import yitian from "@/views/Ditie/sanhaoxian/yitian";
import shixia from "@/views/Ditie/sanhaoxian/shixia";
// import gouwugongyuan from "@/views/Ditie/sanhaoxian/gouwugongyuan"; //站点与1号线交汇，做注释配置
// import futian from "@/views/Ditie/sanhaoxian/futian"; //站点与2号线交汇，做注释配置
import shaoniangong from "@/views/Ditie/sanhaoxian/shaoniangong";
import lianhuacun from "@/views/Ditie/sanhaoxian/lianhuacun";
import huaxin from "@/views/Ditie/sanhaoxian/huaxin";
import tongxinling from "@/views/Ditie/sanhaoxian/tongxinling";
import hongling from "@/views/Ditie/sanhaoxian/hongling";
// import laojie from "@/views/Ditie/sanhaoxian/laojie";  //站点与1号线交汇，做注释配置
import shaibu from "@/views/Ditie/sanhaoxian/shaibu";
import cuizhu from "@/views/Ditie/sanhaoxian/cuizhu";
import tianbei from "@/views/Ditie/sanhaoxian/tianbei";
import shuibei from "@/views/Ditie/sanhaoxian/shuibei";
import caopu from "@/views/Ditie/sanhaoxian/caopu";
import buji from "@/views/Ditie/sanhaoxian/buji";
import mumianwan from "@/views/Ditie/sanhaoxian/mumianwan";
import dafen from "@/views/Ditie/sanhaoxian/dafen";
import danzhutou from "@/views/Ditie/sanhaoxian/danzhutou";
import liuyue from "@/views/Ditie/sanhaoxian/liuyue";
import tangkeng from "@/views/Ditie/sanhaoxian/tangkeng";
import henggang from "@/views/Ditie/sanhaoxian/henggang";
import yonghu from "@/views/Ditie/sanhaoxian/yonghu";
import heao from "@/views/Ditie/sanhaoxian/heao";
import dayun from "@/views/Ditie/sanhaoxian/dayun";
import ailian from "@/views/Ditie/sanhaoxian/ailian";
import jixiang from "@/views/Ditie/sanhaoxian/jixiang";
import longchengguangchang from "@/views/Ditie/sanhaoxian/longchengguangchang";
import nanlian from "@/views/Ditie/sanhaoxian/nanlian";
import shuanglong from "@/views/Ditie/sanhaoxian/shuanglong";

//4号线站点目录
import futiankouan from "@/views/Ditie/sihaoxian/futiankouan";
import fumin from "@/views/Ditie/sihaoxian/fumin";
// import huizhanzhongxin from "@/views/Ditie/sihaoxian/huizhanzhongxin"; //站点与1号线交汇，做注释配置
// import shiminzhongxin from "@/views/Ditie/sihaoxian/shiminzhongxin"; //站点与2号线交汇，做注释配置
// import shaoniangong from "@/views/Ditie/sihaoxian/shaoniangong"; //站点与3号线交汇，做注释配置
import lianhuabei from "@/views/Ditie/sihaoxian/lianhuabei";
import shangmeilin from "@/views/Ditie/sihaoxian/shangmeilin";
import minle from "@/views/Ditie/sihaoxian/minle";
import baishilong from "@/views/Ditie/sihaoxian/baishilong";
import shenzhenbei from "@/views/Ditie/sihaoxian/shenzhenbei";
import hongshan from "@/views/Ditie/sihaoxian/hongshan";
import shangtang from "@/views/Ditie/sihaoxian/shangtang";
import longsheng from "@/views/Ditie/sihaoxian/longsheng";
import longhua from "@/views/Ditie/sihaoxian/longhua";
import qinghu from "@/views/Ditie/sihaoxian/qinghu";
import qinghubei from "@/views/Ditie/sihaoxian/qinghubei";
import zhucun from "@/views/Ditie/sihaoxian/zhucun";
import xikeng from "@/views/Ditie/sihaoxian/xikeng";
import changhu from "@/views/Ditie/sihaoxian/changhu";
import guanlan from "@/views/Ditie/sihaoxian/guanlan";
import songyuanxia from "@/views/Ditie/sihaoxian/songyuanxia";
import guanlanhu from "@/views/Ditie/sihaoxian/guanlanhu";
import niuhu from "@/views/Ditie/sihaoxian/niuhu";

//5号线站点目录 //站点与x号线交汇，做注释配置
// import chiwan from "@/views/Ditie/wuhaoxian/chiwan"; //站点与2号线交汇，做注释配置
import liwan from "@/views/Ditie/wuhaoxian/liwan";
import tielugongyuan from "@/views/Ditie/wuhaoxian/tielugongyuan";
import mawan from "@/views/Ditie/wuhaoxian/mawan";
import qianwangongyuan from "@/views/Ditie/wuhaoxian/qianwangongyuan";
import qianwan from "@/views/Ditie/wuhaoxian/qianwan";
import guiwan from "@/views/Ditie/wuhaoxian/guiwan";
// import qianhaiwan from "@/views/Ditie/wuhaoxian/qianhaiwan"; //站点与1号线交汇，做注释配置
import linhai from "@/views/Ditie/wuhaoxian/linhai";
import baohua from "@/views/Ditie/wuhaoxian/baohua";
// import baoanzhongxin from "@/views/Ditie/wuhaoxian/baoanzhongxin"; //站点与1号线交汇，做注释配置
import fanshen from "@/views/Ditie/wuhaoxian/fanshen";
import lingzhi from "@/views/Ditie/wuhaoxian/lingzhi";
import honglangbei from "@/views/Ditie/wuhaoxian/honglangbei";
import xingdong from "@/views/Ditie/wuhaoxian/xingdong";
import liuxiandong from "@/views/Ditie/wuhaoxian/liuxiandong";
import xili from "@/views/Ditie/wuhaoxian/xili";
import daxuecheng from "@/views/Ditie/wuhaoxian/daxuecheng";
import tanglang from "@/views/Ditie/wuhaoxian/tanglang";
import changlingpi from "@/views/Ditie/wuhaoxian/changlingpi";
// import shenzhenbei from "@/views/Ditie/wuhaoxian/shenzhenbei"; //站点与4号线交汇，做注释配置
import minzhi from "@/views/Ditie/wuhaoxian/minzhi";
import wuhe from "@/views/Ditie/wuhaoxian/wuhe";
import bantian from "@/views/Ditie/wuhaoxian/bantian";
import yangmei from "@/views/Ditie/wuhaoxian/yangmei";
import shangshuijing from "@/views/Ditie/wuhaoxian/shangshuijing";
import xiashuijing from "@/views/Ditie/wuhaoxian/xiashuijing";
import changlong from "@/views/Ditie/wuhaoxian/changlong";
import buji2 from "@/views/Ditie/wuhaoxian/buji2"; //布吉站有3个不同信息，，一个在3号buji，一个在5号buji2,一个在14号buji3.
import baigelong from "@/views/Ditie/wuhaoxian/baigelong";
import buxin from "@/views/Ditie/wuhaoxian/buxin";
import taian from "@/views/Ditie/wuhaoxian/taian";
import yijing from "@/views/Ditie/wuhaoxian/yijing";
// import huangbeiling from "@/views/Ditie/wuhaoxian/huangbeiling"; //站点与2号线交汇，做注释配置

//6号线站点目录 //站点与x号线、x号线交汇，做注释配置
// import kexueguan from "@/views/Ditie/yihaoxian/kexueguan";  //站点与1号线、6号线交汇，做注释配置
// import tongxinling from "@/views/Ditie/sanhaoxian/tongxinling"; //站点与3号线、6号线交汇，做注释配置
import tiyuzhongxin from "@/views/Ditie/liuhaoxian/tiyuzhongxin";
import bagualing from "@/views/Ditie/liuhaoxian/bagualing";
import yinhu from "@/views/Ditie/liuhaoxian/yinhu";
import hanling from "@/views/Ditie/liuhaoxian/hanling";
import meilinguan from "@/views/Ditie/liuhaoxian/meilinguan";
// import shenzhenbei from "@/views/Ditie/sihaoxian/shenzhenbei"; //站点与4号线、5号线、6号线交汇，做注释配置
// import hongshan from "@/views/Ditie/sihaoxian/hongshan";  //站点与4号线、6号线交汇，做注释配置
import shangfen from "@/views/Ditie/liuhaoxian/shangfen";
import yuanfen from "@/views/Ditie/liuhaoxian/yuanfen";
import yangtaishandong from "@/views/Ditie/liuhaoxian/yangtaishandong";
import guantian from "@/views/Ditie/liuhaoxian/guantian";
import shangwu from "@/views/Ditie/liuhaoxian/shangwu";
import changzhen from "@/views/Ditie/liuhaoxian/changzhen";
import fenghuangcheng from "@/views/Ditie/liuhaoxian/fenghuangcheng";
import guangmingdajie from "@/views/Ditie/liuhaoxian/guangmingdajie";
import guangming from "@/views/Ditie/liuhaoxian/guangming";
import kexuegongyuan from "@/views/Ditie/liuhaoxian/kexuegongyuan";
import loucun from "@/views/Ditie/liuhaoxian/loucun";
import honghuashan from "@/views/Ditie/liuhaoxian/honghuashan";
import gongmingguangchang from "@/views/Ditie/liuhaoxian/gongmingguangchang";
import heshuikou from "@/views/Ditie/liuhaoxian/heshuikou";
import shutianpu from "@/views/Ditie/liuhaoxian/shutianpu";
import songganggongyuan from "@/views/Ditie/liuhaoxian/songganggongyuan";
import xitou from "@/views/Ditie/liuhaoxian/xitou";
import songgang from "@/views/Ditie/liuhaoxian/songgang";

//6号线支线站点目录，6-2 //站点与x号线、x号线交汇，做注释配置 liuhaoxianzhixian
// import guangming from "@/views/Ditie/liuhaoxian/guangming";  //站点与6号线、6号线支线交汇，做注释配置
import zhenmei from "@/views/Ditie/liuhaoxianzhixian/zhenmei";
import zhongda from "@/views/Ditie/liuhaoxianzhixian/zhongda";
import shenligong from "@/views/Ditie/liuhaoxianzhixian/shenligong";

//7号线站点目录 //站点与x号线、x号线交汇，做注释配置
import xilihu from "@/views/Ditie/qihaoxian/xilihu";
// import xili from "@/views/Ditie/wuhaoxian/xili"; //站点与5号线、7号线交汇，做注释配置
import chaguang from "@/views/Ditie/qihaoxian/chaguang";
import zhuguang from "@/views/Ditie/qihaoxian/zhuguang";
import longjing from "@/views/Ditie/qihaoxian/longjing";
import taoyuancun from "@/views/Ditie/qihaoxian/taoyuancun";
import shenyun from "@/views/Ditie/qihaoxian/shenyun";
// import antuoshan from "@/views/Ditie/erhaoxian/antuoshan"; //站点与2号线、7号线交汇，做注释配置
import nonglin from "@/views/Ditie/qihaoxian/nonglin";
// import chegongmiao from "@/views/Ditie/yihaoxian/chegongmiao"; //站点与1号线、7号线、9号线、11号线交汇，做注释配置
import shangsha from "@/views/Ditie/qihaoxian/shangsha";
import shawei from "@/views/Ditie/qihaoxian/shawei";
// import shixia from "@/views/Ditie/sanhaoxian/shixia"; //站点与3号线、7号线交汇，做注释配置
import huanggangcun from "@/views/Ditie/qihaoxian/huanggangcun";
// import fumin from "@/views/Ditie/sihaoxian/fumin"; //站点与4号线、7号线、10号线交汇，做注释配置
import huanggangkouan from "@/views/Ditie/qihaoxian/huanggangkouan";
import fulin from "@/views/Ditie/qihaoxian/fulin";
import chiwei from "@/views/Ditie/qihaoxian/chiwei";
import huaqiangnan from "@/views/Ditie/qihaoxian/huaqiangnan";
// import huaqiangbei from "@/views/Ditie/erhaoxian/huaqiangbei"; //站点与2号线、7号线交汇，做注释配置
// import huaxin from "@/views/Ditie/sanhaoxian/huaxin"; //站点与3号线、7号线交汇，做注释配置
import huangmugang from "@/views/Ditie/qihaoxian/huangmugang"; //站点与7号线、14号线交汇 不做注释配置
// import bagualing from "@/views/Ditie/liuhaoxian/bagualing"; //站点与6号线、7号线交汇，做注释配置
import honglingbei from "@/views/Ditie/qihaoxian/honglingbei"; //站点与7号线、9号线交汇 不做注释配置
import sungang from "@/views/Ditie/qihaoxian/sungang";
import honghu from "@/views/Ditie/qihaoxian/honghu";
// import tianbei from "@/views/Ditie/sanhaoxian/tianbei"; //站点与3号线、7号线交汇，做注释配置
// import taian from "@/views/Ditie/wuhaoxian/taian"; //站点与5号线、7号线交汇，做注释配置

//8号线站点目录 //站点与x号线、x号线交汇，做注释配置
import wutongshannan from "@/views/Ditie/bahaoxian/wutongshannan";
import shatoujiao from "@/views/Ditie/bahaoxian/shatoujiao";
import haishan from "@/views/Ditie/bahaoxian/haishan";
import yantiangangxi from "@/views/Ditie/bahaoxian/yantiangangxi";
import shenwaigaozhong from "@/views/Ditie/bahaoxian/shenwaigaozhong";
import yantianlu from "@/views/Ditie/bahaoxian/yantianlu";

//9号线站点目录 //站点与x号线、x号线交汇，做注释配置
// import qianwan from "@/views/Ditie/wuhaoxian/qianwan"; //站点与5号线、9号线交汇，做注释配置
import menghai from "@/views/Ditie/jiuhaoxian/menghai";
import yihai from "@/views/Ditie/jiuhaoxian/yihai";
import lilin from "@/views/Ditie/jiuhaoxian/lilin";
import nanyouxi from "@/views/Ditie/jiuhaoxian/nanyouxi";
import nanyou from "@/views/Ditie/jiuhaoxian/nanyou";
import nanshanshucheng from "@/views/Ditie/jiuhaoxian/nanshanshucheng";
import shendanan from "@/views/Ditie/jiuhaoxian/shendanan";
import yuehaimen from "@/views/Ditie/jiuhaoxian/yuehaimen";
import gaoxinnan from "@/views/Ditie/jiuhaoxian/gaoxinnan";
import hongshuwannan from "@/views/Ditie/jiuhaoxian/hongshuwannan";
import shenwan from "@/views/Ditie/jiuhaoxian/shenwan";
import shenzhenwangongyuan from "@/views/Ditie/jiuhaoxian/shenzhenwangongyuan";
import xiasha from "@/views/Ditie/jiuhaoxian/xiasha";
// import chegongmiao from "@/views/Ditie/yihaoxian/chegongmiao"; //站点与1号线、7号线、9号线、11号线交汇，做注释配置
import xiangmei from "@/views/Ditie/jiuhaoxian/xiangmei";
// import jingtian from "@/views/Ditie/erhaoxian/jingtian"; //站点与2号线、9号线交汇，做注释配置
import meijing from "@/views/Ditie/jiuhaoxian/meijing";
import xiameilin from "@/views/Ditie/jiuhaoxian/xiameilin";
import meicun from "@/views/Ditie/jiuhaoxian/meicun";
// import shangmeilin from "@/views/Ditie/sihaoxian/shangmeilin"; //站点与4号线、9号线交汇，做注释配置
import maling from "@/views/Ditie/jiuhaoxian/maling";
// import yinhu from "@/views/Ditie/liuhaoxian/yinhu"; //站点与6号线、9号线交汇，做注释配置
import nigang from "@/views/Ditie/jiuhaoxian/nigang";
// import honglingbei from "@/views/Ditie/qihaoxian/honglingbei"; //站点与7号线、9号线交汇，做注释配置
import yuanling from "@/views/Ditie/jiuhaoxian/yuanling";
// import hongling from "@/views/Ditie/sanhaoxian/hongling"; //站点与3号线、9号线交汇，做注释配置
import honglingnan from "@/views/Ditie/jiuhaoxian/honglingnan";
import ludancun from "@/views/Ditie/jiuhaoxian/ludancun";
import renminnan from "@/views/Ditie/jiuhaoxian/renminnan";
import xiangxicun from "@/views/Ditie/jiuhaoxian/xiangxicun";
import wenjin from "@/views/Ditie/jiuhaoxian/wenjin";


//10号线站点目录 //站点与x号线、x号线交汇，做注释配置
// import futiankouan from "@/views/Ditie/sihaoxian/futiankouan"; //站点与4号线、10号线交汇，做注释配置
// import fumin from "@/views/Ditie/sihaoxian/fumin"; //站点与4号线、7号线、10号线交汇，做注释配置
// import gangxia from "@/views/Ditie/yihaoxian/gangxia"; //站点与1号线、10号线交汇，做注释配置
import gangxiabei2 from "@/views/Ditie/shihaoxian/gangxiabei2"; //岗厦北gangxiabe2站点是与10号线、11号线交汇，另一个是gangxiabei,是2号线和14号线交汇。
// import lianhuacun from "@/views/Ditie/sanhaoxian/lianhuacun"; //站点与3号线、10号线交汇，做注释配置
import donggualing from "@/views/Ditie/shihaoxian/donggualing";
// import maling from "@/views/Ditie/jiuhaoxian/maling"; //站点与9号线、10号线交汇，做注释配置
import yabao from "@/views/Ditie/shihaoxian/yabao";
import nankeng from "@/views/Ditie/shihaoxian/nankeng";
import guangyayuan from "@/views/Ditie/shihaoxian/guangyayuan";
// import wuhe from "@/views/Ditie/wuhaoxian/wuhe"; //站点与5号线、10号线交汇，做注释配置
import bantianbei from "@/views/Ditie/shihaoxian/bantianbei";
import beierlu from "@/views/Ditie/shihaoxian/beierlu";
import huawei from "@/views/Ditie/shihaoxian/huawei";
import gangtou from "@/views/Ditie/shihaoxian/gangtou";
import xuexiang from "@/views/Ditie/shihaoxian/xuexiang";
import gankeng from "@/views/Ditie/shihaoxian/gankeng";
import liangmaoshan from "@/views/Ditie/shihaoxian/liangmaoshan";
import shanglilang from "@/views/Ditie/shihaoxian/shanglilang";
import mugu from "@/views/Ditie/shihaoxian/mugu";
import huanancheng from "@/views/Ditie/shihaoxian/huanancheng";
import hehua from "@/views/Ditie/shihaoxian/hehua";
import pinghu from "@/views/Ditie/shihaoxian/pinghu";
import shuangyongjie from "@/views/Ditie/shihaoxian/shuangyongjie";

// //11号线站点目录 //站点与x号线、x号线交汇，做注释配置
// // import gangxiabei2 from "@/views/Ditie/shihaoxian/gangxiabei2"; //gangxiabei2 站点与10号线、11号线交汇，做注释配置
// // import futian from "@/views/Ditie/erhaoxian/futian"; //站点与2号线、3号线、11号线交汇，做注释配置
// // import chegongmiao from "@/views/Ditie/qihaoxian/chegongmiao"; //站点与7号线、9号线、11号线交汇，做注释配置
// // import hongshuwannan from "@/views/Ditie/jiuhaoxian/hongshuwannan"; //站点与9号线、11号线交汇，做注释配置
import huohai from "@/views/Ditie/shiyihaoxian/huohai";
import nanshan from "@/views/Ditie/shiyihaoxian/nanshan";
// // import qianhaiwan from "@/views/Ditie/yihaoxian/qianhaiwan"; //站点与1号线、5号线、11号线交汇，做注释配置
import baoan from "@/views/Ditie/shiyihaoxian/baoan";
import bihaiwan from "@/views/Ditie/shiyihaoxian/bihaiwan";
import jichang from "@/views/Ditie/shiyihaoxian/jichang";
import jichangbei from "@/views/Ditie/shiyihaoxian/jichangbei";
import fuyong from "@/views/Ditie/shiyihaoxian/fuyong";
import qiaotou from "@/views/Ditie/shiyihaoxian/qiaotou";
import tangwei from "@/views/Ditie/shiyihaoxian/tangwei";
import maanshan from "@/views/Ditie/shiyihaoxian/maanshan";
import shajing from "@/views/Ditie/shiyihaoxian/shajing";
import houting from "@/views/Ditie/shiyihaoxian/houting";
// import songgang from "@/views/Ditie/liuhaoxian/songgang"; //站点与6号线、11号线交汇，做注释配置
import bitou from "@/views/Ditie/shiyihaoxian/bitou";

//12号线站点目录 //站点与x号线、x号线交汇，做注释配置
import zuopaotaidong from "@/views/Ditie/shierhaoxian/zuopaotaidong";
import taiziwan from "@/views/Ditie/shierhaoxian/taiziwan";
import haishangshijie2 from "@/views/Ditie/shierhaoxian/haishangshijie2"; //站点为2个站点信息，此为haishangshijie2.
import huaguoshan from "@/views/Ditie/shierhaoxian/huaguoshan";
import sihai from "@/views/Ditie/shierhaoxian/sihai";
// import nanyou from "@/views/Ditie/jiuhaoxian/nanyou"; //站点与9号线、12号线交汇，做注释配置
import nanguang from "@/views/Ditie/shierhaoxian/nanguang";
// import nanshan from "@/views/Ditie/shiyihaoxian/nanshan"; //站点与11号线、12号线交汇，做注释配置
// import taoyuan from "@/views/Ditie/yihaoxian/taoyuan"; //站点与1号线、12号线交汇，做注释配置
import nantougucheng from "@/views/Ditie/shierhaoxian/nantougucheng";
import zhongshangongyuan from "@/views/Ditie/shierhaoxian/zhongshangongyuan";
import tonglenan from "@/views/Ditie/shierhaoxian/tonglenan";
import xinangongyuan from "@/views/Ditie/shierhaoxian/xinangongyuan";
import lingzhi2 from "@/views/Ditie/shierhaoxian/lingzhi2"; //站点与5号线、12号线交汇，此站点信息有一个，5号线lingzhi.12号线lingzhi2.
import shangchuan from "@/views/Ditie/shierhaoxian/shangchuan";
import liutang from "@/views/Ditie/shierhaoxian/liutang";
import baoankeyunzhan from "@/views/Ditie/shierhaoxian/baoankeyunzhan";
import baotianyilu from "@/views/Ditie/shierhaoxian/baotianyilu";
import pingluanshan from "@/views/Ditie/shierhaoxian/pingluanshan";
import xixiangtaoyuan from "@/views/Ditie/shierhaoxian/xixiangtaoyuan";
import zhongwunan from "@/views/Ditie/shierhaoxian/zhongwunan";
import huangtian from "@/views/Ditie/shierhaoxian/huangtian";
import xingwei from "@/views/Ditie/shierhaoxian/xingwei";
// import jichangdong from "@/views/Ditie/yihaoxian/jichangdong"; //站点与1号线、12号线交汇，做注释配置
import fuwei from "@/views/Ditie/shierhaoxian/fuwei";
import huaide from "@/views/Ditie/shierhaoxian/huaide";
// import fuyong from "@/views/Ditie/shiyihaoxian/fuyong"; //站点与11号线、12号线交汇，做注释配置
import qiaotouxi from "@/views/Ditie/shierhaoxian/qiaotouxi";
import fuhaixi from "@/views/Ditie/shierhaoxian/fuhaixi";
import guozhan from "@/views/Ditie/shierhaoxian/guozhan";
import guozhanbei from "@/views/Ditie/shierhaoxian/guozhanbei";
import haishangtianyuannan from "@/views/Ditie/shierhaoxian/haishangtianyuannan";
import haishangtianyuandong from "@/views/Ditie/shierhaoxian/haishangtianyuandong";



//14号线站点目录 //站点与x号线、x号线交汇，做注释配置
// import gangxiabei from "@/views/Ditie/erhaoxian/gangxiabei"; //站点与2号线、14号线交汇，做注释配置
// import huangmugang from "@/views/Ditie/qihaoxian/huangmugang"; //站点与7号线、14号线交汇，做注释配置
import luohubei from "@/views/Ditie/shisihaoxian/luohubei";
import buji3 from "@/views/Ditie/shisihaoxian/buji3"; //布吉站有3个不同信息，，一个在3号buji.一个在5号buji2，另一个在14号,buji3.
import shiyaling from "@/views/Ditie/shisihaoxian/shiyaling";
import liuyuebei from "@/views/Ditie/shisihaoxian/liuyuebei";
import silian from "@/views/Ditie/shisihaoxian/silian";
import aobei from "@/views/Ditie/shisihaoxian/aobei";
import dayun2 from "@/views/Ditie/shisihaoxian/dayun2"; //大运站有3个不同信息，，一个在3号dayun.一个在14号dayun2，另一个在16号,dayun3.
import zhangbei from "@/views/Ditie/shisihaoxian/zhangbei";
import nanyue from "@/views/Ditie/shisihaoxian/nanyue";
import baolong from "@/views/Ditie/shisihaoxian/baolong";
import jinlong from "@/views/Ditie/shisihaoxian/jinlong";
import pingshanwei from "@/views/Ditie/shisihaoxian/pingshanwei";
import pingshanguangchang from "@/views/Ditie/shisihaoxian/pingshanguangchang";
import pingshanzhongxin from "@/views/Ditie/shisihaoxian/pingshanzhongxin";
import kengzi from "@/views/Ditie/shisihaoxian/kengzi";
import shatian from "@/views/Ditie/shisihaoxian/shatian";


//16号线站点目录 //站点与x号线、x号线交汇，做注释配置
import dayun3 from "@/views/Ditie/shiliuhaoxian/dayun3"; //大运站有3个不同信息，一个在3号dayun.一个在14号dayun2，另一个在16号,dayun3.
import dayunzhongxin from "@/views/Ditie/shiliuhaoxian/dayunzhongxin";
import longchenggongyuan from "@/views/Ditie/shiliuhaoxian/longchenggongyuan";
import huanggekeng from "@/views/Ditie/shiliuhaoxian/huanggekeng";
import yuyuan from "@/views/Ditie/shiliuhaoxian/yuyuan";
import huilongpu from "@/views/Ditie/shiliuhaoxian/huilongpu";
import shangjing from "@/views/Ditie/shiliuhaoxian/shangjing";
import shengping from "@/views/Ditie/shiliuhaoxian/shengping";
import longyuan from "@/views/Ditie/shiliuhaoxian/longyuan";
import shuanglong2 from "@/views/Ditie/shiliuhaoxian/shuanglong2";  //双龙 shuanglong有2个不同信息，，一个在3号shuanglong.一个在16号shuanglong2
import xintangwei from "@/views/Ditie/shiliuhaoxian/xintangwei";
import longdong from "@/views/Ditie/shiliuhaoxian/longdong";
import baolongtongle from "@/views/Ditie/shiliuhaoxian/baolongtongle";
import pingshan from "@/views/Ditie/shiliuhaoxian/pingshan";
import xinhe from "@/views/Ditie/shiliuhaoxian/xinhe";
import liuhe from "@/views/Ditie/shiliuhaoxian/liuhe";
import pingshanwei2 from "@/views/Ditie/shiliuhaoxian/pingshanwei2"; //坪山围站有2个不同信息，，一个在14号pingshanwei.一个在16号pingshanwei2
import pinghuan from "@/views/Ditie/shiliuhaoxian/pinghuan";
import dongzongjinianguan from "@/views/Ditie/shiliuhaoxian/dongzongjinianguan";
import shabo from "@/views/Ditie/shiliuhaoxian/shabo";
import yanzihu from "@/views/Ditie/shiliuhaoxian/yanzihu";
import shijing from "@/views/Ditie/shiliuhaoxian/shijing";
import jishudaxue from "@/views/Ditie/shiliuhaoxian/jishudaxue";
import tianxin from "@/views/Ditie/shiliuhaoxian/tianxin";


//20号线站点目录 //站点与x号线、x号线交汇，做注释配置
import jichangbei2 from "@/views/Ditie/ershihaoxian/jichangbei2"; //机场北 jichangbei有2个不同信息，，一个在11号jichangbei.一个在20号jichangbei2
import guozhannan from "@/views/Ditie/ershihaoxian/guozhannan";
// import guozhan from "@/views/Ditie/shierhaoxian/guozhan"; //站点与12号线、20号线交汇，做注释配置
// import guozhanbei from "@/views/Ditie/shierhaoxian/guozhanbei"; //站点与12号线、20号线交汇，做注释配置
import huizhancheng from "@/views/Ditie/ershihaoxian/huizhancheng";







//公交配置 #gongjiao
//1.左边一级目录 1  mulu
import Gongjiao from "@/views/Gongjiao";

//2.右边公交站点目录 mulu1  gongjiaoxianlupeizi-1配置 #gongjiao #公交线路路径配置
// 模板配置 import x from "@/views/Gongjiao/x";
import shenzhentong from "@/views/Gongjiao/shenzhentong"; //深圳通
import gongjiaozhandian from "@/views/Gongjiao/gongjiaozhandian"; //公交站点
import e3 from "@/views/Gongjiao/e3";
import a3 from "@/views/Gongjiao/a3";
import m313 from "@/views/Gongjiao/m313";
import m528 from "@/views/Gongjiao/m528";
import m539 from "@/views/Gongjiao/m539";
import gj74 from "@/views/Gongjiao/74";
import gj122 from "@/views/Gongjiao/122";
import gaofengzhuanxian165 from "@/views/Gongjiao/gaofengzhuanxian165";
import gaokuaibashi29 from "@/views/Gongjiao/gaokuaibashi29";
import gj1 from "@/views/Gongjiao/1";
import gj2 from "@/views/Gongjiao/2";
import gj3 from "@/views/Gongjiao/3";
import gj4 from "@/views/Gongjiao/4";
import gj5 from "@/views/Gongjiao/5";
import gj7 from "@/views/Gongjiao/7";
import gj8 from "@/views/Gongjiao/8";
import gj10 from "@/views/Gongjiao/10";
import gj11 from "@/views/Gongjiao/11";
import gj12 from "@/views/Gongjiao/12";
import gj13 from "@/views/Gongjiao/13";
import gj14 from "@/views/Gongjiao/14";
import gj17 from "@/views/Gongjiao/17";
import gj18 from "@/views/Gongjiao/18";
import gj19 from "@/views/Gongjiao/19";
import gj21 from "@/views/Gongjiao/21";
import gj22 from "@/views/Gongjiao/22";
import gj23 from "@/views/Gongjiao/23";
import gj26 from "@/views/Gongjiao/26";
import gj27 from "@/views/Gongjiao/27";
import gj29 from "@/views/Gongjiao/29";
import gj34 from "@/views/Gongjiao/34";
import gj37 from "@/views/Gongjiao/37";
import gj38 from "@/views/Gongjiao/38";
import gj41 from "@/views/Gongjiao/41";
import gj42 from "@/views/Gongjiao/42";
import gj43 from "@/views/Gongjiao/43";
import gj44 from "@/views/Gongjiao/44";
import gj49 from "@/views/Gongjiao/49";
import gj52 from "@/views/Gongjiao/52";
import gj57 from "@/views/Gongjiao/57";
import gj58 from "@/views/Gongjiao/58";
import gj60 from "@/views/Gongjiao/60";
import gj61 from "@/views/Gongjiao/61";
import gj62 from "@/views/Gongjiao/62";
import gj63 from "@/views/Gongjiao/63";
import gj64 from "@/views/Gongjiao/64";
import gj66 from "@/views/Gongjiao/66";
import gj67 from "@/views/Gongjiao/67";
import gj68 from "@/views/Gongjiao/68";
import gj69 from "@/views/Gongjiao/69";
import gj71 from "@/views/Gongjiao/71";
import gj72 from "@/views/Gongjiao/72";
import gj73 from "@/views/Gongjiao/73";
import gj75 from "@/views/Gongjiao/75";


//3.右边公交站点目录 mulu1  gongjiaoxianlupeizi-1配置 gongjiaoxianlu/gongjiaozhandian/x #gongjiao
import zhishengjichang from "@/views/Gongjiao/gongjiaozhandian/zhishengjichang";

//4. 以下代码暂时停用，等以后需要用到，才启用。 #gongjiao
//e3路公交站点目录 e3-mulu2  e3-gongjiao2配置
//模板代码 import  from "@/views/Gongjiao/e3/"; 
// import guangmingzhenmeizongzhan from "@/views/Gongjiao/e3/guangmingzhenmeizongzhan";  //1
// import zhongshanqiyuanhuanchengzhan from "@/views/Gongjiao/e3/zhongshanqiyuanhuanchengzhan";  //2
// import zhenmeilukou from "@/views/Gongjiao/e3/zhenmeilukou";  //3    
// import zhenmeishichang from "@/views/Gongjiao/e3/zhenmeishichang";  //4 
// import loucunxiaoxue from "@/views/Gongjiao/e3/loucunxiaoxue";  //5   
// import xinhupaichusuo from "@/views/Gongjiao/e3/xinhupaichusuo";  //6 
// import guangminghongmuxiaozhen from "@/views/Gongjiao/e3/guangminghongmuxiaozhen";  //7 
// import yongjingchengxi from "@/views/Gongjiao/e3/yongjingchengxi";  //8 
// import honghuazhenminglukou from "@/views/Gongjiao/e3/honghuazhenminglukou";  //9 
// import guokedayiyuanxiyuanqu2 from "@/views/Gongjiao/e3/guokedayiyuanxiyuanqu2";  //10  
// import jiangshi from "@/views/Gongjiao/e3/jiangshi";  //11 
// import jiangwei from "@/views/Gongjiao/e3/jiangwei";  //12 
// import guangmingtangwei from "@/views/Gongjiao/e3/guangmingtangwei";  //13 
// import minghugongyuandong from "@/views/Gongjiao/e3/minghugongyuandong";  //14 
// import hongfagaoxinchanyeyuan from "@/views/Gongjiao/e3/hongfagaoxinchanyeyuan";  //15 
// import zhishengjichang from "@/views/Gongjiao/e3/zhishengjichang";  //16
// import yanxiangkejidasha1 from "@/views/Gongjiao/e3/yanxiangkejidasha1";  //17
// import shenzhendaxue from "@/views/Gongjiao/e3/shenzhendaxue";  //18 
// import xieheshenzhenyiyuandong from "@/views/Gongjiao/e3/xieheshenzhenyiyuandong";  //19 
// import nanhanggongsi from "@/views/Gongjiao/e3/nanhanggongsi";  //20
// import nanshanpaichusuo from "@/views/Gongjiao/e3/nanshanpaichusuo";  //21
// import zhongyoudasha from "@/views/Gongjiao/e3/zhongyoudasha";  //22
// import nanyuancundong from "@/views/Gongjiao/e3/nanyuancundong";  //23
// import chengshishanlindong from "@/views/Gongjiao/e3/chengshishanlindong";  //24 
// import nanyouxidetiezhan from "@/views/Gongjiao/e3/nanyouxidetiezhan";  //25
// import lixiuwenhuajie from "@/views/Gongjiao/e3/lixiuwenhuajie";  //26
// import nanmenyifang from "@/views/Gongjiao/e3/nanmenyifang";  //27
// import beishidafuzhong from "@/views/Gongjiao/e3/beishidafuzhong";  //28
// import houhaibinlukou from "@/views/Gongjiao/e3/houhaibinlukou";  //29
// import shenzhenwankouangongjiaoshoumozhan from "@/views/Gongjiao/e3/shenzhenwankouangongjiaoshoumozhan";  //30


// 所有gongjiao站点目录配置 x-gongjiao2配置 #gongjiao
// 模板代码 import  from "@/views/Gongjiao/e3/"; 

//a3路公交站点目录 a3-mulu2  a3-gongjiao2配置
//模板代码 import  from "@/views/Gongjiao/e3/"; 


//m313路公交站点目录 m313-mulu2  m313-gongjiao2配置
//模板代码 import xxx from "@/views/Gongjiao/m313/xxx"; 

//m528路公交站点目录 m528-mulu2  m528-gongjiao2配置
// import xxx from "@/views/Gongjiao/m528/xxx";

//m539路公交站点目录 m539-mulu2  m539-gongjiao2配置
// import xxx from "@/views/Gongjiao/m539/xxx";

//gj74路公交站点目录 gj74-mulu2  gj74-gongjiao2配置
// import xxx from "@/views/Gongjiao/74/xxx";

//gj122路公交站点目录 gj122-mulu2  gj122-gongjiao2配置
// import xxx from "@/views/Gongjiao/122/xxx";

//gaofengzhuanxian165公交站点目录 gaofengzhuanxian165-mulu2  gaofengzhuanxian165-gongjiao2配置
// import xxx from "@/views/Gongjiao/gaofengzhuanxian165/xxx";

//gaokuaibashi29公交站点目录 gaokuaibashi29-mulu2  gaokuaibashi29-gongjiao2配置
// import xxx from "@/views/Gongjiao/gaokuaibashi29/xxx";

// 所有gongjiao站点目录配置 gj1-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/1/"; 

// 所有gongjiao站点目录配置 gj2-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/2/"; 

// 所有gongjiao站点目录配置 gj3-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/3/"; 

// 所有gongjiao站点目录配置 gj4-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/4/"; 

// 所有gongjiao站点目录配置 gj5-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/5/"; 

// 所有gongjiao站点目录配置 gj7-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/7/"; 

// 所有gongjiao站点目录配置 gj8-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/8/"; 

// 所有gongjiao站点目录配置 gj10-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/10/"; 

// 所有gongjiao站点目录配置 gj11-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/11/"; 

// 所有gongjiao站点目录配置 gj12-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/12/"; 

// 所有gongjiao站点目录配置 gj13-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/13/"; 

// gj14-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/14/"; 

// gj17-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/17/";

// gj18-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/18/";

// gj19-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/19/";

// gj21-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/21/";

// gj22-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/22/";

// gj23-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/23/";

// gj26-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/26/";

// gj27-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/27/";

// gj29-gongjiao2配置
// 模板代码 import  from "@/views/Gongjiao/29/";

// gj34-gongjiao2配置
//  import x from "@/views/Gongjiao/34/x";

// gj37-gongjiao2配置
//  import x from "@/views/Gongjiao/37/x";

// gj38-gongjiao2配置
//  import x from "@/views/Gongjiao/38/x";

// gj41-gongjiao2配置
//  import x from "@/views/Gongjiao/41/x";

// gj42-gongjiao2配置
//  import x from "@/views/Gongjiao/42/x";

// gj43-gongjiao2配置
//  import x from "@/views/Gongjiao/43/x";

// gj44-gongjiao2配置
//  import x from "@/views/Gongjiao/44/x";

// gj49-gongjiao2配置
//  import x from "@/views/Gongjiao/49/x";

// gj52-gongjiao2配置
//  import x from "@/views/Gongjiao/52/x";

// gj57-gongjiao2配置
//  import x from "@/views/Gongjiao/57/x";

// gj58-gongjiao2配置
//  import x from "@/views/Gongjiao/58/x";

// gj60-gongjiao2配置
//  import x from "@/views/Gongjiao/60/x";

// gj61-gongjiao2配置
//  import x from "@/views/Gongjiao/61/x";

// gj62-gongjiao2配置
//  import x from "@/views/Gongjiao/62/x";

// gj63-gongjiao2配置
//  import x from "@/views/Gongjiao/63/x";

// gj64-gongjiao2配置
//  import x from "@/views/Gongjiao/64/x";

// gj66-gongjiao2配置
//  import x from "@/views/Gongjiao/66/x";

// gj67-gongjiao2配置
//  import x from "@/views/Gongjiao/67/x";

// gj68-gongjiao2配置
//  import x from "@/views/Gongjiao/68/x";

// gj69-gongjiao2配置
//  import x from "@/views/Gongjiao/69/x";





//出租车配置 #chuzuche
//左边一级目录 1  mulu
import Chuzuche from "@/views/Chuzuche";



//高铁配置 #gaotie
//左边一级目录 1  mulu
import Gaotie from "@/views/Gaotie";



//机场配置 #jichang
//左边一级目录 1  mulu
import Jichang from "@/views/Jichang";


//轮船配置 #lunchuan
//左边一级目录 1  mulu
import Lunchuan from "@/views/Lunchuan";



//核酸配置，应急项目配置，备用项 #hesuan #beiyon
//左边一级目录 1  mulu
// import Hesuan from "@/views/Hesuan";








//第二大项配置 #deerdaxiang #no.2
export default [

  // 左边一级目录 2 mulu4 
  //导航分类和深圳地铁所有线路

  // #backups
  //Home #home 默认打页主页指向Home,路径为/,也即是/Home/index.vue文件
  // { name: "Home", path: "/", component: Home },

  //Home #home 改为 #Gongjiao 功能为打页指向Gongjiao页，也即是/Gongjiao/index.vue文件
  // 由 { name: "Home", path: "/", component: Home },改为 
  // { name: "Gongjiao", path: "/", component: Gongjiao },
  { name: "Gongjiao", path: "/", component: Gongjiao },



  //Fengliebiao #fengliebiao
  { name: "Fengliebiao", path: "/Fengliebiao", component: Fengliebiao },




  //地铁 #ditie
  { name: "Ditie", path: "/Ditie", component: Ditie },

  //导航地铁线路1 #ditie
  { name: "yihaoxian", path: "/Ditie/yihaoxian", component: yihaoxian },
//导航地铁线路2
  { name: "erhaoxian", path: "/Ditie/erhaoxian", component: erhaoxian },
//导航地铁线路3
  { name: "sanhaoxian", path: "/Ditie/sanhaoxian", component: sanhaoxian },
//导航地铁线路4
  { name: "sihaoxian", path: "/Ditie/sihaoxian", component: sihaoxian },
//导航地铁线路5
  { name: "wuhaoxian", path: "/Ditie/wuhaoxian", component: wuhaoxian },
//导航地铁线路6
  { name: "liuhaoxian", path: "/Ditie/liuhaoxian", component: liuhaoxian },
//导航地铁线路6-2,6号线支线
{ name: "liuhaoxianzhixian", path: "/Ditie/liuhaoxianzhixian", component: liuhaoxianzhixian },
//导航地铁线路7
  { name: "qihaoxian", path: "/Ditie/qihaoxian", component: qihaoxian },
//导航地铁线路8
  { name: "bahaoxian", path: "/Ditie/bahaoxian", component: bahaoxian },
//导航地铁线路9
  { name: "jiuhaoxian", path: "/Ditie/jiuhaoxian", component: jiuhaoxian },
//导航地铁线路10
  { name: "shihaoxian", path: "/Ditie/shihaoxian", component: shihaoxian },
//导航地铁线路11
  { name: "shiyihaoxian", path: "/Ditie/shiyihaoxian", component: shiyihaoxian },
//导航地铁线路12
  { name: "shierhaoxian", path: "/Ditie/shierhaoxian", component: shierhaoxian },
//导航地铁线路14
  { name: "shisihaoxian", path: "/Ditie/shisihaoxian", component: shisihaoxian },
//导航地铁线路16
  { name: "shiliuhaoxian", path: "/Ditie/shiliuhaoxian", component: shiliuhaoxian },
//导航地铁线路20
  { name: "ershihaoxian", path: "/Ditie/ershihaoxian", component: ershihaoxian },

  //导航地铁线路站点 #ditie
//1号线站点
{ name: "louhu", path: "/Ditie/yihaoxian/luohu", component: luohu },
{ name: "guomao", path: "/Ditie/yihaoxian/guomao", component: guomao },
{ name: "laojie", path: "/Ditie/yihaoxian/laojie", component: laojie },
{ name: "dajuyuan", path: "/Ditie/yihaoxian/dajuyuan", component: dajuyuan },
{ name: "kexueguan", path: "/Ditie/yihaoxian/kexueguan", component: kexueguan },
{ name: "huaqianglu", path: "/Ditie/yihaoxian/huaqianglu", component: huaqianglu },
{ name: "gangxia", path: "/Ditie/yihaoxian/gangxia", component: gangxia },
{ name: "huizhanzhongxin", path: "/Ditie/yihaoxian/huizhanzhongxin", component: huizhanzhongxin },
{ name: "gouwugongyuan", path: "/Ditie/yihaoxian/gouwugongyuan", component: gouwugongyuan },
{ name: "xiangmihu", path: "/Ditie/yihaoxian/xiangmihu", component: xiangmihu },
{ name: "chegongmiao", path: "/Ditie/yihaoxian/chegongmiao", component: chegongmiao },
{ name: "zhuzilin", path: "/Ditie/yihaoxian/zhuzilin", component: zhuzilin },
{ name: "qiaochengdong", path: "/Ditie/yihaoxian/qiaochengdong", component: qiaochengdong },
{ name: "huaqiaocheng", path: "/Ditie/yihaoxian/huaqiaocheng", component: huaqiaocheng },
{ name: "shijiezhichuang", path: "/Ditie/yihaoxian/shijiezhichuang", component: shijiezhichuang },
{ name: "baishizhou", path: "/Ditie/yihaoxian/baishizhou", component: baishizhou },
{ name: "gaoxinyuan", path: "/Ditie/yihaoxian/gaoxinyuan", component: gaoxinyuan },
{ name: "shenda", path: "/Ditie/yihaoxian/shenda", component: shenda },
{ name: "taoyuan", path: "/Ditie/yihaoxian/taoyuan", component: taoyuan },
{ name: "daxin", path: "/Ditie/yihaoxian/daxin", component: daxin },
{ name: "liyumen", path: "/Ditie/yihaoxian/liyumen", component: liyumen },
{ name: "qianhaiwan", path: "/Ditie/yihaoxian/qianhaiwan", component: qianhaiwan },
{ name: "xinan", path: "/Ditie/yihaoxian/xinan", component: xinan },
{ name: "baoanzhongxin", path: "/Ditie/yihaoxian/baoanzhongxin", component: baoanzhongxin },
{ name: "baoti", path: "/Ditie/yihaoxian/baoti", component: baoti },
{ name: "pingzhou", path: "/Ditie/yihaoxian/pingzhou", component: pingzhou },
{ name: "xixiang", path: "/Ditie/yihaoxian/xixiang", component: xixiang },
{ name: "gushu", path: "/Ditie/yihaoxian/gushu", component: gushu },
{ name: "hourui", path: "/Ditie/yihaoxian/hourui", component: hourui },
{ name: "jichangdong", path: "/Ditie/yihaoxian/jichangdong", component: jichangdong },

//2号线站点
{ name: "chiwan", path: "/Ditie/erhaoxian/chiwan", component: chiwan },
{ name: "shekougang", path: "/Ditie/erhaoxian/shekougang", component: shekougang },
{ name: "haishangshijie", path: "/Ditie/erhaoxian/haishangshijie", component: haishangshijie },
{ name: "shuiwan", path: "/Ditie/erhaoxian/shuiwan", component: shuiwan },
{ name: "dongjiaotou", path: "/Ditie/erhaoxian/dongjiaotou", component: dongjiaotou },
{ name: "wanxia", path: "/Ditie/erhaoxian/wanxia", component: wanxia },
{ name: "haiyue", path: "/Ditie/erhaoxian/haiyue", component: haiyue },
{ name: "dengliang", path: "/Ditie/erhaoxian/dengliang", component: dengliang },
{ name: "houhai", path: "/Ditie/erhaoxian/houhai", component: houhai },
{ name: "keyuan", path: "/Ditie/erhaoxian/keyuan", component: keyuan },
{ name: "hongshuwan", path: "/Ditie/erhaoxian/hongshuwan", component: hongshuwan },
{ name: "shijiezhichuang", path: "/Ditie/yihaoxian/shijiezhichuang", component: shijiezhichuang }, //站点信息目录指向1号线路由路径
{ name: "qiaochengbei", path: "/Ditie/erhaoxian/qiaochengbei", component: qiaochengbei },
{ name: "shenkang", path: "/Ditie/erhaoxian/shenkang", component: shenkang },
{ name: "antuoshan", path: "/Ditie/erhaoxian/antuoshan", component: antuoshan },
{ name: "qiaoxiang", path: "/Ditie/erhaoxian/qiaoxiang", component: qiaoxiang },
{ name: "xiangmi", path: "/Ditie/erhaoxian/xiangmi", component: xiangmi },
{ name: "xiangmeibei", path: "/Ditie/erhaoxian/xiangmeibei", component: xiangmeibei },
{ name: "jingtian", path: "/Ditie/erhaoxian/jingtian", component: jingtian },
{ name: "lianhuaxi", path: "/Ditie/erhaoxian/lianhuaxi", component: lianhuaxi },
{ name: "futian", path: "/Ditie/erhaoxian/futian", component: futian },
{ name: "shiminzhongxin", path: "/Ditie/erhaoxian/shiminzhongxin", component: shiminzhongxin },
{ name: "gangxiabei", path: "/Ditie/erhaoxian/gangxiabei", component: gangxiabei },
{ name: "huaqiangbei", path: "/Ditie/erhaoxian/huaqiangbei", component: huaqiangbei },
{ name: "yannan", path: "/Ditie/erhaoxian/yannan", component: yannan },
{ name: "dajuyuan", path: "/Ditie/yihaoxian/dajuyuan", component: dajuyuan }, //站点信息目录指向1号线路由路径
{ name: "hubei", path: "/Ditie/erhaoxian/hubei", component: hubei },
{ name: "huangbeiling", path: "/Ditie/erhaoxian/huangbeiling", component: huangbeiling },
{ name: "xinxiu", path: "/Ditie/erhaoxian/xinxiu", component: xinxiu },
{ name: "liantangkouan", path: "/Ditie/erhaoxian/liantangkouan", component: liantangkouan },
{ name: "xianhulu", path: "/Ditie/erhaoxian/xianhulu", component: xianhulu },
{ name: "liantang", path: "/Ditie/erhaoxian/liantang", component: liantang },

//3号线站点   //站点信息目录指向x号线路由路径
{ name: "fubao", path: "/Ditie/sanhaoxian/fubao", component: fubao },
{ name: "yitian", path: "/Ditie/sanhaoxian/yitian", component: yitian },
{ name: "shixia", path: "/Ditie/sanhaoxian/shixia", component: shixia },
{ name: "gouwugongyuan", path: "/Ditie/yihaoxian/gouwugongyuan", component: gouwugongyuan }, //站点信息目录指向1号线路由路径
{ name: "futian", path: "/Ditie/erhaoxian/futian", component: futian }, //站点信息目录指向2号线路由路径
{ name: "shaoniangong", path: "/Ditie/sanhaoxian/shaoniangong", component: shaoniangong },
{ name: "lianhuacun", path: "/Ditie/sanhaoxian/lianhuacun", component: lianhuacun },
{ name: "huaxin", path: "/Ditie/sanhaoxian/huaxin", component: huaxin },
{ name: "tongxinling", path: "/Ditie/sanhaoxian/tongxinling", component: tongxinling },
{ name: "hongling", path: "/Ditie/sanhaoxian/hongling", component: hongling },
{ name: "laojie", path: "/Ditie/yihaoxian/laojie", component: laojie }, //站点信息目录指向1号线路由路径
{ name: "shaibu", path: "/Ditie/sanhaoxian/shaibu", component: shaibu },
{ name: "cuizhu", path: "/Ditie/sanhaoxian/cuizhu", component: cuizhu },
{ name: "tianbei", path: "/Ditie/sanhaoxian/tianbei", component: tianbei },
{ name: "shuibei", path: "/Ditie/sanhaoxian/shuibei", component: shuibei },
{ name: "caopu", path: "/Ditie/sanhaoxian/caopu", component: caopu },
{ name: "buji", path: "/Ditie/sanhaoxian/buji", component: buji },
{ name: "mumianwan", path: "/Ditie/sanhaoxian/mumianwan", component: mumianwan },
{ name: "dafen", path: "/Ditie/sanhaoxian/dafen", component: dafen },
{ name: "danzhutou", path: "/Ditie/sanhaoxian/danzhutou", component: danzhutou },
{ name: "liuyue", path: "/Ditie/sanhaoxian/liuyue", component: liuyue },
{ name: "tangkeng", path: "/Ditie/sanhaoxian/tangkeng", component: tangkeng },
{ name: "henggang", path: "/Ditie/sanhaoxian/henggang", component: henggang },
{ name: "yonghu", path: "/Ditie/sanhaoxian/yonghu", component: yonghu },
{ name: "heao", path: "/Ditie/sanhaoxian/heao", component: heao },
{ name: "dayun", path: "/Ditie/sanhaoxian/dayun", component: dayun },
{ name: "ailian", path: "/Ditie/sanhaoxian/ailian", component: ailian },
{ name: "jixiang", path: "/Ditie/sanhaoxian/jixiang", component: jixiang },
{ name: "longchengguangchang", path: "/Ditie/sanhaoxian/longchengguangchang", component: longchengguangchang },
{ name: "nanlian", path: "/Ditie/sanhaoxian/nanlian", component: nanlian },
{ name: "shuanglong", path: "/Ditie/sanhaoxian/shuanglong", component: shuanglong },

//4号线站点
{ name: "futiankouan", path: "/Ditie/sihaoxian/futiankouan", component: futiankouan },
{ name: "fumin", path: "/Ditie/sihaoxian/fumin", component: fumin },
{ name: "huizhanzhongxin", path: "/Ditie/yihaoxian/huizhanzhongxin", component: huizhanzhongxin }, //站点信息目录指向1号线路由路径
{ name: "shiminzhongxin", path: "/Ditie/erhaoxian/shiminzhongxin", component: shiminzhongxin }, //站点信息目录指向2号线路由路径
{ name: "shaoniangong", path: "/Ditie/sanhaoxian/shaoniangong", component: shaoniangong }, //站点信息目录指向3号线路由路径
{ name: "lianhuabei", path: "/Ditie/sihaoxian/lianhuabei", component: lianhuabei },
{ name: "shangmeilin", path: "/Ditie/sihaoxian/shangmeilin", component: shangmeilin },
{ name: "minle", path: "/Ditie/sihaoxian/minle", component: minle },
{ name: "baishilong", path: "/Ditie/sihaoxian/baishilong", component: baishilong },
{ name: "shenzhenbei", path: "/Ditie/sihaoxian/shenzhenbei", component: shenzhenbei },
{ name: "hongshan", path: "/Ditie/sihaoxian/hongshan", component: hongshan },
{ name: "shangtang", path: "/Ditie/sihaoxian/shangtang", component: shangtang },
{ name: "longsheng", path: "/Ditie/sihaoxian/longsheng", component: longsheng },
{ name: "longhua", path: "/Ditie/sihaoxian/longhua", component: longhua },
{ name: "qinghu", path: "/Ditie/sihaoxian/qinghu", component: qinghu },
{ name: "qinghubei", path: "/Ditie/sihaoxian/qinghubei", component: qinghubei },
{ name: "zhucun", path: "/Ditie/sihaoxian/zhucun", component: zhucun },
{ name: "xikeng", path: "/Ditie/sihaoxian/xikeng", component: xikeng },
{ name: "changhu", path: "/Ditie/sihaoxian/changhu", component: changhu },
{ name: "guanlan", path: "/Ditie/sihaoxian/guanlan", component: guanlan },
{ name: "songyuanxia", path: "/Ditie/sihaoxian/songyuanxia", component: songyuanxia },
{ name: "guanlanhu", path: "/Ditie/sihaoxian/guanlanhu", component: guanlanhu },
{ name: "niuhu", path: "/Ditie/sihaoxian/niuhu", component: niuhu },

  //5号线站点  //站点信息目录指向x号线路由路径
  // { name: "chiwan", path: "/Ditie/erhaoxian/chiwan", component: chiwan },  //站点信息目录指向2号线路由路径
  { name: "liwan", path: "/Ditie/wuhaoxian/liwan", component: liwan },
  { name: "tielugongyuan", path: "/Ditie/wuhaoxian/tielugongyuan", component: tielugongyuan },
  { name: "mawan", path: "/Ditie/wuhaoxian/mawan", component: mawan },
  { name: "qianwangongyuan", path: "/Ditie/wuhaoxian/qianwangongyuan", component: qianwangongyuan },
  { name: "qianwan", path: "/Ditie/wuhaoxian/qianwan", component: qianwan },
  { name: "guiwan", path: "/Ditie/wuhaoxian/guiwan", component: guiwan },
  { name: "qianhaiwan", path: "/Ditie/wuhaoxian/qianhaiwan", component: qianhaiwan },
  { name: "linhai", path: "/Ditie/wuhaoxian/linhai", component: linhai },
  { name: "baohua", path: "/Ditie/wuhaoxian/baohua", component: baohua },
  { name: "baoanzhongxin", path: "/Ditie/wuhaoxian/baoanzhongxin", component: baoanzhongxin },
  { name: "fanshen", path: "/Ditie/wuhaoxian/fanshen", component: fanshen },
  { name: "lingzhi", path: "/Ditie/wuhaoxian/lingzhi", component: lingzhi },
  { name: "honglangbei", path: "/Ditie/wuhaoxian/honglangbei", component: honglangbei },
  { name: "xingdong", path: "/Ditie/wuhaoxian/xingdong", component: xingdong },
  { name: "liuxiandong", path: "/Ditie/wuhaoxian/liuxiandong", component: liuxiandong },
  { name: "xili", path: "/Ditie/wuhaoxian/xili", component: xili },
  { name: "daxuecheng", path: "/Ditie/wuhaoxian/daxuecheng", component: daxuecheng },
  { name: "tanglang", path: "/Ditie/wuhaoxian/tanglang", component: tanglang },
  { name: "changlingpi", path: "/Ditie/wuhaoxian/changlingpi", component: changlingpi },
  { name: "shenzhenbei", path: "/Ditie/wuhaoxian/shenzhenbei", component: shenzhenbei },
  { name: "minzhi", path: "/Ditie/wuhaoxian/minzhi", component: minzhi },
  { name: "wuhe", path: "/Ditie/wuhaoxian/wuhe", component: wuhe },
  { name: "bantian", path: "/Ditie/wuhaoxian/bantian", component: bantian },
  { name: "yangmei", path: "/Ditie/wuhaoxian/yangmei", component: yangmei },
  { name: "shangshuijing", path: "/Ditie/wuhaoxian/shangshuijing", component: shangshuijing },
  { name: "xiashuijing", path: "/Ditie/wuhaoxian/xiashuijing", component: xiashuijing },
  { name: "changlong", path: "/Ditie/wuhaoxian/changlong", component: changlong },
  { name: "buji2", path: "/Ditie/wuhaoxian/buji2", component: buji2 }, //布吉站有3个不同信息，，一个在3号buji，一个在5号buji2,一个在14号buji3.
  { name: "baigelong", path: "/Ditie/wuhaoxian/baigelong", component: baigelong },
  { name: "buxin", path: "/Ditie/wuhaoxian/buxin", component: buxin },
  { name: "taian", path: "/Ditie/wuhaoxian/taian", component: taian },
  { name: "yijing", path: "/Ditie/wuhaoxian/yijing", component: yijing },
  { name: "huangbeiling", path: "/Ditie/wuhaoxian/huangbeiling", component: huangbeiling },

  //6号线站点  //站点信息目录指向x号线路由路径
  { name: "kexueguan", path: "/Ditie/yihaoxian/kexueguan", component: kexueguan }, //站点信息目录指向1号线路由路径
  { name: "tongxinling", path: "/Ditie/sanhaoxian/tongxinling", component: tongxinling }, //站点信息目录指向3号线路由路径
  { name: "tiyuzhongxin", path: "/Ditie/liuhaoxian/tiyuzhongxin", component: tiyuzhongxin },
  { name: "bagualing", path: "/Ditie/liuhaoxian/bagualing", component: bagualing },
  { name: "yinhu", path: "/Ditie/liuhaoxian/yinhu", component: yinhu },
  { name: "hanling", path: "/Ditie/liuhaoxian/hanling", component: hanling },
  { name: "meilinguan", path: "/Ditie/liuhaoxian/meilinguan", component: meilinguan },
  { name: "shenzhenbei", path: "/Ditie/sihaoxian/shenzhenbei", component: shenzhenbei }, //站点信息目录指向4号线路由路径
  { name: "hongshan", path: "/Ditie/sihaoxian/hongshan", component: hongshan }, //站点信息目录指向4号线路由路径
  { name: "shangfen", path: "/Ditie/liuhaoxian/shangfen", component: shangfen },
  { name: "yuanfen", path: "/Ditie/liuhaoxian/yuanfen", component: yuanfen },
  { name: "yangtaishandong", path: "/Ditie/liuhaoxian/yangtaishandong", component: yangtaishandong },
  { name: "guantian", path: "/Ditie/liuhaoxian/guantian", component: guantian },
  { name: "shangwu", path: "/Ditie/liuhaoxian/shangwu", component: shangwu },
  { name: "changzhen", path: "/Ditie/liuhaoxian/changzhen", component: changzhen },
  { name: "fenghuangcheng", path: "/Ditie/liuhaoxian/fenghuangcheng", component: fenghuangcheng },
  { name: "guangmingdajie", path: "/Ditie/liuhaoxian/guangmingdajie", component: guangmingdajie },
  { name: "guangming", path: "/Ditie/liuhaoxian/guangming", component: guangming },
  { name: "kexuegongyuan", path: "/Ditie/liuhaoxian/kexuegongyuan", component: kexuegongyuan },
  { name: "loucun", path: "/Ditie/liuhaoxian/loucun", component: loucun },
  { name: "honghuashan", path: "/Ditie/liuhaoxian/honghuashan", component: honghuashan },
  { name: "gongmingguangchang", path: "/Ditie/liuhaoxian/gongmingguangchang", component: gongmingguangchang },
  { name: "heshuikou", path: "/Ditie/liuhaoxian/heshuikou", component: heshuikou },
  { name: "shutianpu", path: "/Ditie/liuhaoxian/shutianpu", component: shutianpu },
  { name: "songganggongyuan", path: "/Ditie/liuhaoxian/songganggongyuan", component: songganggongyuan },
  { name: "xitou", path: "/Ditie/liuhaoxian/xitou", component: xitou },
  { name: "songgang", path: "/Ditie/liuhaoxian/songgang", component: songgang },


  //6号线支线站点，6-2    //站点信息目录指向x号线路由路径
  { name: "guangming", path: "/Ditie/liuhaoxian/guangming", component: guangming },  //站点信息目录指向x号线路由路径
  { name: "zhenmei", path: "/Ditie/liuhaoxianzhixian/zhenmei", component: zhenmei },
  { name: "zhongda", path: "/Ditie/liuhaoxianzhixian/zhongda", component: zhongda },
  { name: "shenligong", path: "/Ditie/liuhaoxianzhixian/shenligong", component: shenligong },

  //7号线站点    //站点信息目录指向x号线路由路径
  { name: "xilihu", path: "/Ditie/qihaoxian/xilihu", component: xilihu },
  { name: "xili", path: "/Ditie/wuhaoxian/xili", component: xili }, //站点信息目录指向5号线路由路径
  { name: "chaguang", path: "/Ditie/qihaoxian/chaguang", component: chaguang },
  { name: "zhuguang", path: "/Ditie/qihaoxian/zhuguang", component: zhuguang },
  { name: "longjing", path: "/Ditie/qihaoxian/longjing", component: longjing },
  { name: "taoyuancun", path: "/Ditie/qihaoxian/taoyuancun", component: taoyuancun },
  { name: "shenyun", path: "/Ditie/qihaoxian/shenyun", component: shenyun },
  { name: "antuoshan", path: "/Ditie/erhaoxian/antuoshan", component: antuoshan }, //站点信息目录指向2号线路由路径
  { name: "nonglin", path: "/Ditie/qihaoxian/nonglin", component: nonglin },
  { name: "chegongmiao", path: "/Ditie/yihaoxian/chegongmiao", component: chegongmiao }, //站点信息目录指向1号线路由路径
  { name: "shangsha", path: "/Ditie/qihaoxian/shangsha", component: shangsha },
  { name: "shawei", path: "/Ditie/qihaoxian/shawei", component: shawei },
  { name: "shixia", path: "/Ditie/sanhaoxian/shixia", component: shixia }, //站点信息目录指向3号线路由路径
  { name: "huanggangcun", path: "/Ditie/qihaoxian/huanggangcun", component: huanggangcun },
  { name: "fumin", path: "/Ditie/sihaoxian/fumin", component: fumin }, //站点信息目录指向4号线路由路径
  { name: "huanggangkouan", path: "/Ditie/qihaoxian/huanggangkouan", component: huanggangkouan },
  { name: "fulin", path: "/Ditie/qihaoxian/fulin", component: fulin },
  { name: "chiwei", path: "/Ditie/qihaoxian/chiwei", component: chiwei },
  { name: "huaqiangnan", path: "/Ditie/qihaoxian/huaqiangnan", component: huaqiangnan },
  { name: "huaqiangbei", path: "/Ditie/erhaoxian/huaqiangbei", component: huaqiangbei }, //站点信息目录指向2号线路由路径
  { name: "huaxin", path: "/Ditie/sanhaoxian/huaxin", component: huaxin }, //站点信息目录指向3号线路由路径
  { name: "huangmugang", path: "/Ditie/qihaoxian/huangmugang", component: huangmugang },
  { name: "bagualing", path: "/Ditie/liuhaoxian/bagualing", component: bagualing }, //站点信息目录指向6号线路由路径
  { name: "honglingbei", path: "/Ditie/qihaoxian/honglingbei", component: honglingbei },
  { name: "sungang", path: "/Ditie/qihaoxian/sungang", component: sungang },
  { name: "honghu", path: "/Ditie/qihaoxian/honghu", component: honghu },
  { name: "tianbei", path: "/Ditie/sanhaoxian/tianbei", component: tianbei }, //站点信息目录指向3号线路由路径
  { name: "taian", path: "/Ditie/wuhaoxian/taian", component: taian }, //站点信息目录指向5号线路由路径

  //8号线站点    //站点信息目录指向x号线路由路径
  { name: "wutongshannan", path: "/Ditie/bahaoxian/wutongshannan", component: wutongshannan },
  { name: "shatoujiao", path: "/Ditie/bahaoxian/shatoujiao", component: shatoujiao },
  { name: "haishan", path: "/Ditie/bahaoxian/haishan", component: haishan },
  { name: "yantiangangxi", path: "/Ditie/bahaoxian/yantiangangxi", component: yantiangangxi },
  { name: "shenwaigaozhong", path: "/Ditie/bahaoxian/shenwaigaozhong", component: shenwaigaozhong },
  { name: "yantianlu", path: "/Ditie/bahaoxian/yantianlu", component: yantianlu },

  //9号线站点    //站点信息目录指向x号线路由路径
  { name: "qianwan", path: "/Ditie/wuhaoxian/qianwan", component: qianwan }, //站点与5号线、9号线交汇，做注释配置
  { name: "menghai", path: "/Ditie/jiuhaoxianmenghai", component: menghai },
  { name: "yihai", path: "/Ditie/jiuhaoxian/yihai", component: yihai },
  { name: "lilin", path: "/Ditie/jiuhaoxian/lilin", component: lilin },
  { name: "nanyouxi", path: "/Ditie/jiuhaoxian/nanyouxi", component: nanyouxi },
  { name: "nanyou", path: "/Ditie/jiuhaoxian/nanyou", component: nanyou },
  { name: "nanshanshucheng", path: "/Ditie/jiuhaoxian/nanshanshucheng", component: nanshanshucheng },
  { name: "shendanan", path: "/Ditie/jiuhaoxian/shendanan", component: shendanan },
  { name: "yuehaimen", path: "/Ditie/jiuhaoxian/yuehaimen", component: yuehaimen },
  { name: "gaoxinnan", path: "/Ditie/jiuhaoxian/gaoxinnan", component: gaoxinnan },
  { name: "hongshuwannan", path: "/Ditie/jiuhaoxian/hongshuwannan", component: hongshuwannan },
  { name: "shenwan", path: "/Ditie/jiuhaoxian/shenwan", component: shenwan },
  { name: "shenzhenwangongyuan", path: "/Ditie/jiuhaoxian/shenzhenwangongyuan", component: shenzhenwangongyuan },
  { name: "xiasha", path: "/Ditie/jiuhaoxian/xiasha", component: xiasha },
  { name: "chegongmiao", path: "/Ditie/yihaoxian/chegongmiao", component: chegongmiao }, //站点与1号线、7号线、9号线、11号线交汇，做注释配置
  { name: "xiangmei", path: "/Ditie/jiuhaoxian/xiangmei", component: xiangmei },
  { name: "jingtian", path: "/Ditie/erhaoxian/jingtian", component: jingtian }, //站点与2号线、9号线交汇，做注释配置
  { name: "meijing", path: "/Ditie/jiuhaoxian/meijing", component: meijing },
  { name: "xiameilin", path: "/Ditie/jiuhaoxian/xiameilin", component: xiameilin },
  { name: "meicun", path: "/Ditie/jiuhaoxian/meicun", component: meicun },
  { name: "shangmeilin", path: "/Ditie/sihaoxian/shangmeilin", component: shangmeilin }, //站点与4号线、9号线交汇，做注释配置
  { name: "maling", path: "/Ditie/jiuhaoxian/maling", component: maling },
  { name: "yinhu", path: "/Ditie/liuhaoxian/yinhu", component: yinhu }, //站点与6号线、9号线交汇，做注释配置
  { name: "nigang", path: "/Ditie/jiuhaoxian/nigang", component: nigang },
  { name: "honglingbei", path: "/Ditie/qihaoxian/honglingbei", component: honglingbei }, //站点与7号线、9号线交汇，做注释配置
  { name: "yuanling", path: "/Ditie/jiuhaoxian/yuanling", component: yuanling },
  { name: "hongling", path: "/Ditie/sanhaoxian/hongling", component: hongling }, //站点与3号线、9号线交汇，做注释配置
  { name: "honglingnan", path: "/Ditie/jiuhaoxian/honglingnan", component: honglingnan },
  { name: "ludancun", path: "/Ditie/jiuhaoxian/ludancun", component: ludancun },
  { name: "renminnan", path: "/Ditie/jiuhaoxian/renminnan", component: renminnan },
  { name: "xiangxicun", path: "/Ditie/jiuhaoxian/xiangxicun", component: xiangxicun },
  { name: "wenjin", path: "/Ditie/jiuhaoxian/wenjin", component: wenjin },

//10号线站点    //站点信息目录指向x号线路由路径
  { name: "futiankouan", path: "/Ditie/sihaoxian/futiankouan", component: futiankouan }, //站点信息目录指向4号线路由路径
  { name: "fumin", path: "/Ditie/sihaoxian/fumin", component: fumin },  //站点信息目录指向4号线路由路径
  { name: "gangxia", path: "/Ditie/yihaoxian/gangxia", component: gangxia }, //站点信息目录指向1号线路由路径
  { name: "gangxiabei2", path: "/Ditie/shihaoxian/gangxiabei2", component: gangxiabei2 }, //岗厦北gangxiabei2站点信息目录,指向10号线和11号线交叉
  { name: "lianhuacun", path: "/Ditie/sanhaoxian/lianhuacun", component: lianhuacun }, //站点信息目录指向3号线路由路径
  { name: "donggualing", path: "/Ditie/shihaoxian/donggualing", component: donggualing },
  { name: "maling", path: "/Ditie/jiuhaoxian/maling", component: maling }, //站点信息目录指向9号线路由路径
  { name: "yabao", path: "/Ditie/shihaoxian/yabao", component: yabao },
  { name: "nankeng", path: "/Ditie/shihaoxian/nankeng", component: nankeng },
  { name: "guangyayuan", path: "/Ditie/shihaoxian/guangyayuan", component: guangyayuan },
  { name: "wuhe", path: "/Ditie/wuhaoxian/wuhe", component: wuhe }, //站点信息目录指向5号线路由路径
  { name: "bantianbei", path: "/Ditie/shihaoxian/bantianbei", component: bantianbei },
  { name: "beierlu", path: "/Ditie/shihaoxian/beierlu", component: beierlu },
  { name: "huawei", path: "/Ditie/shihaoxian/huawei", component: huawei },
  { name: "gangtou", path: "/Ditie/shihaoxian/gangtou", component: gangtou },
  { name: "xuexiang", path: "/Ditie/shihaoxian/xuexiang", component: xuexiang },
  { name: "gankeng", path: "/Ditie/shihaoxian/gankeng", component: gankeng },
  { name: "liangmaoshan", path: "/Ditie/shihaoxian/liangmaoshan", component: liangmaoshan },
  { name: "shanglilang", path: "/Ditie/shihaoxianshanglilang/", component: shanglilang },
  { name: "mugu", path: "/Ditie/shihaoxian/mugu", component: mugu },
  { name: "huanancheng", path: "/Ditie/shihaoxian/huanancheng", component: huanancheng },
  { name: "hehua", path: "/Ditie/shihaoxian/hehua", component: hehua },
  { name: "pinghu", path: "/Ditie/shihaoxian/pinghu", component: pinghu },
  { name: "shuangyongjie", path: "/Ditie/shihaoxian/shuangyongjie", component: shuangyongjie },

    //11号线站点    //站点信息目录指向x号线路由路径
    { name: "gangxiabei2", path: "/Ditie/shihaoxian/gangxiabei2", component: gangxiabei2 }, //站点信息目录指向10号线路由路径
    { name: "futian", path: "/Ditie/erhaoxian/futian", component: futian },  //站点信息目录指向2号线路由路径
    { name: "chegongmiao", path: "/Ditie/yihaoxian/chegongmiao", component: chegongmiao },  //站点信息目录指向1号线路由路径
    { name: "hongshuwannan", path: "/Ditie/jiuhaoxian/hongshuwannan", component: hongshuwannan },  //站点信息目录指向9号线路由路径
    { name: "huohai", path: "/Ditie/shiyihaoxian/huohai", component: huohai },
    { name: "nanshan", path: "/Ditie/shiyihaoxian/nanshan", component: nanshan },
    { name: "qianhaiwan", path: "/Ditie/yihaoxian/qianhaiwan", component: qianhaiwan },  //站点信息目录指向1号线路由路径
    { name: "baoan", path: "/Ditie/shiyihaoxian/baoan", component: baoan },
    { name: "bihaiwan", path: "/Ditie/shiyihaoxian/bihaiwan", component: bihaiwan },
    { name: "jichang", path: "/Ditie/shiyihaoxian/jichang", component: jichang },
    { name: "jichangbei", path: "/Ditie/shiyihaoxian/jichangbei", component: jichangbei },
    { name: "fuyong", path: "/Ditie/shiyihaoxian/fuyong", component: fuyong },
    { name: "qiaotou", path: "/Ditie/shiyihaoxian/qiaotou", component: qiaotou },
    { name: "tangwei", path: "/Ditie/shiyihaoxian/tangwei", component: tangwei },
    { name: "maanshan", path: "/Ditie/shiyihaoxian/maanshan", component: maanshan },
    { name: "shajing", path: "/Ditie/shiyihaoxian/shajing", component: shajing },
    { name: "houting", path: "/Ditie/shiyihaoxian/houting", component: houting },
    { name: "songgang", path: "/Ditie/liuhaoxian/songgang", component: songgang },  //站点信息目录指向6号线路由路径
    { name: "bitou", path: "/Ditie/shiyihaoxian/bitou", component: bitou },

    //12号线站点    //站点信息目录指向x号线路由路径
    { name: "zuopaotaidong", path: "/Ditie/shierhaoxian/zuopaotaidong", component: zuopaotaidong },
    { name: "taiziwan", path: "/Ditie/shierhaoxian/taiziwan", component: taiziwan },
    { name: "haishangshijie2", path: "/Ditie/shierhaoxian/haishangshijie2", component: haishangshijie2 }, //站点信息目录指向12号线路由路径
    { name: "huaguoshan", path: "/Ditie/shierhaoxian/huaguoshan", component: huaguoshan },
    { name: "sihai", path: "/Ditie/shierhaoxian/sihai", component: sihai },
    { name: "nanyou", path: "/Ditie/jiuhaoxian/nanyou", component: nanyou }, //站点信息目录指向9号线路由路径
    { name: "nanguang", path: "/Ditie/shierhaoxian/nanguang", component: nanguang },
    { name: "nanshan", path: "/Ditie/shiyihaoxian/nanshan", component: nanshan }, //站点信息目录指向11号线路由路径
    { name: "taoyuan", path: "/Ditie/yihaoxian/taoyuan", component: taoyuan }, //站点信息目录指向1号线路由路径
    { name: "nantougucheng", path: "/Ditie/shierhaoxian/nantougucheng", component: nantougucheng },
    { name: "zhongshangongyuan", path: "/Ditie/shierhaoxian/zhongshangongyuan", component: zhongshangongyuan },
    { name: "tonglenan", path: "/Ditie/shierhaoxian/tonglenan", component: tonglenan },
    { name: "xinangongyuan", path: "/Ditie/shierhaoxian/xinangongyuan", component: xinangongyuan },
    { name: "lingzhi2", path: "/Ditie/shierhaoxian/lingzhi2", component: lingzhi2 }, //站点信息目录指向12号线路由路径,此站为两个，一个是5号线lingzhi。另一个在12号线lingzhi2.
    { name: "shangchuan", path: "/Ditie/shierhaoxian/shangchuan", component: shangchuan },
    { name: "liutang", path: "/Ditie/shierhaoxian/liutang", component: liutang },
    { name: "baoankeyunzhan", path: "/Ditie/shierhaoxian/baoankeyunzhan", component: baoankeyunzhan },
    { name: "baotianyilu", path: "/Ditie/shierhaoxian/baotianyilu", component: baotianyilu },
    { name: "pingluanshan", path: "/Ditie/shierhaoxian/pingluanshan", component: pingluanshan },
    { name: "xixiangtaoyuan", path: "/Ditie/shierhaoxian/xixiangtaoyuan", component: xixiangtaoyuan },
    { name: "zhongwunan", path: "/Ditie/shierhaoxian/zhongwunan", component: zhongwunan },
    { name: "huangtian", path: "/Ditie/shierhaoxian/huangtian", component: huangtian },
    { name: "xingwei", path: "/Ditie/shierhaoxian/xingwei", component: xingwei },
    { name: "jichangdong", path: "/Ditie/yihaoxian/jichangdong", component: jichangdong }, //站点信息目录指向1号线路由路径
    { name: "fuwei", path: "/Ditie/shierhaoxian/fuwei", component: fuwei },
    { name: "huaide", path: "/Ditie/shierhaoxian/huaide", component: huaide },
    { name: "fuyong", path: "/Ditie/shiyihaoxian/fuyong", component: fuyong }, //站点信息目录指向11号线路由路径
    { name: "qiaotouxi", path: "/Ditie/shierhaoxian/qiaotouxi", component: qiaotouxi },
    { name: "fuhaixi", path: "/Ditie/shierhaoxian/fuhaixi", component: fuhaixi },
    { name: "guozhan", path: "/Ditie/shierhaoxian/guozhan", component: guozhan },
    { name: "guozhanbei", path: "/Ditie/shierhaoxian/guozhanbei", component: guozhanbei },
    { name: "haishangtianyuannan", path: "/Ditie/shierhaoxian/haishangtianyuannan", component: haishangtianyuannan },
    { name: "haishangtianyuandong", path: "/Ditie/shierhaoxian/haishangtianyuandong", component: haishangtianyuandong },



    //14号线站点    //站点信息目录指向x号线路由路径
    { name: "gangxiabei", path: "/Ditie/erhaoxian/gangxiabei", component: gangxiabei }, //站点信息目录指向2号线路由路径
    { name: "huangmugang", path: "/Ditie/qihaoxian/huangmugang", component: huangmugang }, //站点信息目录指向7号线路由路径
    { name: "luohubei", path: "/Ditie/shisihaoxian/luohubei", component: luohubei },
    { name: "buji3", path: "/Ditie/shisihaoxian/buji3", component: buji3 }, //布吉站有3个不同信息，，一个在3号buji.一个在5号buji2，另一个在14号,buji3.
    { name: "shiyaling", path: "/Ditie/shisihaoxian/shiyaling", component: shiyaling },
    { name: "liuyuebei", path: "/Ditie/shisihaoxian/liuyuebei", component: liuyuebei },
    { name: "silian", path: "/Ditie/shisihaoxian/silian", component: silian },
    { name: "aobei", path: "/Ditie/shisihaoxian/aobei", component: aobei },
    { name: "dayun2", path: "/Ditie/shisihaoxian/dayun2", component: dayun2 }, //大运站有3个不同信息，，一个在3号dayun.一个在14号dayun2，另一个在16号,dayun3.
    { name: "zhangbei", path: "/Ditie/shisihaoxian/zhangbei", component: zhangbei },
    { name: "nanyue", path: "/Ditie/shisihaoxian/nanyue", component: nanyue },
    { name: "baolong", path: "/Ditie/shisihaoxian/baolong", component: baolong },
    { name: "jinlong", path: "/Ditie/shisihaoxian/jinlong", component: jinlong },
    { name: "pingshanwei", path: "/Ditie/shisihaoxian/pingshanwei", component: pingshanwei },
    { name: "pingshanguangchang", path: "/Ditie/shisihaoxian/pingshanguangchang", component: pingshanguangchang },
    { name: "pingshanzhongxin", path: "/Ditie/shisihaoxian/pingshanzhongxin", component: pingshanzhongxin },
    { name: "kengzi", path: "/Ditie/shisihaoxian/kengzi", component: kengzi },
    { name: "shatian", path: "/Ditie/shisihaoxian/shatian", component: shatian },


    //16号线站点    //站点信息目录指向x号线路由路径
    { name: "dayun3", path: "/Ditie/shiliuhaoxian/dayun3", component: dayun3 }, //大运站有3个不同信息，，一个在3号dayun.一个在14号dayun2，另一个在16号,dayun3.
    { name: "dayunzhongxin", path: "/Ditie/shiliuhaoxian/dayunzhongxin", component: dayunzhongxin },
    { name: "longchenggongyuan", path: "/Ditie/shiliuhaoxian/longchenggongyuan", component: longchenggongyuan },
    { name: "huanggekeng", path: "/Ditie/shiliuhaoxian/huanggekeng", component: huanggekeng },
    { name: "yuyuan", path: "/Ditie/shiliuhaoxian/yuyuan", component: yuyuan },
    { name: "huilongpu", path: "/Ditie/shiliuhaoxian/huilongpu", component: huilongpu },
    { name: "shangjing", path: "/Ditie/shiliuhaoxian/shangjing", component: shangjing },
    { name: "shengping", path: "/Ditie/shiliuhaoxian/shengping", component: shengping },
    { name: "longyuan", path: "/Ditie/shiliuhaoxian/longyuan", component: longyuan },
    { name: "shuanglong2", path: "/Ditie/shiliuhaoxian/shuanglong2", component: shuanglong2 },
    { name: "xintangwei", path: "/Ditie/shiliuhaoxian/xintangwei", component: xintangwei },
    { name: "longdong", path: "/Ditie/shiliuhaoxian/longdong", component: longdong },
    { name: "baolongtongle", path: "/Ditie/shiliuhaoxian/baolongtongle", component: baolongtongle },
    { name: "pingshan", path: "/Ditie/shiliuhaoxian/pingshan", component: pingshan },
    { name: "xinhe", path: "/Ditie/shiliuhaoxian/xinhe", component: xinhe },
    { name: "liuhe", path: "/Ditie/shiliuhaoxian/liuhe", component: liuhe },
    { name: "pingshanwei2", path: "/Ditie/shiliuhaoxian/pingshanwei2", component: pingshanwei2 }, //坪山围站有2个不同信息，，一个在14号pingshanwei.一个在16号pingshanwei2
    { name: "pinghuan", path: "/Ditie/shiliuhaoxian/pinghuan", component: pinghuan },
    { name: "dongzongjinianguan", path: "/Ditie/shiliuhaoxian/dongzongjinianguan", component: dongzongjinianguan },
    { name: "shabo", path: "/Ditie/shiliuhaoxian/shabo", component: shabo },
    { name: "yanzihu", path: "/Ditie/shiliuhaoxian/yanzihu", component: yanzihu },
    { name: "shijing", path: "/Ditie/shiliuhaoxian/shijing", component: shijing },
    { name: "jishudaxue", path: "/Ditie/shiliuhaoxian/jishudaxue", component: jishudaxue },
    { name: "tianxin", path: "/Ditie/shiliuhaoxian/tianxin", component: tianxin },

    //20号线站点    //站点信息目录指向x号线路由路径
    { name: "jichangbei2", path: "/Ditie/ershihaoxian/jichangbei2", component: jichangbei2 }, //机场北 jichangbei有2个不同信息，，一个在11号jichangbei.一个在20号jichangbei2
    { name: "guozhannan", path: "/Ditie/ershihaoxian/guozhannan", component: guozhannan },
    { name: "guozhan", path: "/Ditie/shierhaoxian/guozhan", component: guozhan }, //站点信息目录指向12号线路由路径
    { name: "guozhanbei", path: "/Ditie/shierhaoxian/guozhanbei", component: guozhanbei }, //站点信息目录指向12号线路由路径
    { name: "huizhancheng", path: "/Ditie/ershihaoxian/huizhancheng", component: huizhancheng },


  //公交 #gongjiao
  { name: "Gongjiao", path: "/Gongjiao", component: Gongjiao },

  //导航公交所有线路 mulu4 x-mulu4 x-gongjiao3配置
//模板
//{ name: "x", path: "/Gongjiao/x", component: x },


//导航公交所有线路 shenzhentong-mulu4 shenzhentong-gongjiao3配置 公交站点  #gongjiao #公交线路路径配置
{ name: "shenzhentong", path: "/Gongjiao/shenzhentong", component: shenzhentong },

//导航公交所有线路 gongjiaozhandian-mulu4 gongjiaozhandian-gongjiao3配置 公交站点
{ name: "gongjiaozhandian", path: "/Gongjiao/gongjiaozhandian", component: gongjiaozhandian },

//导航公交线路E3 e3-mulu4 e3-gongjiao3配置

  { name: "e3", path: "/Gongjiao/e3", component: e3 },

//导航公交线路A3 a3-mulu4 a3-gongjiao3配置
  { name: "a3", path: "/Gongjiao/a3", component: a3 },

 //导航公交线路M313 m313-mulu4 m313-gongjiao3配置
  { name: "m313", path: "/Gongjiao/m313", component: m313 },

//导航公交线路M528 m528-mulu4 m528-gongjiao3配置
  { name: "m528", path: "/Gongjiao/m528", component: m528 },

  //导航公交线路M539 m539-mulu4 m539-gongjiao3配置
  { name: "m539", path: "/Gongjiao/m539", component: m539 },

  //导航公交线路74 74-mulu4 74-gongjiao3配置
  { name: "gj74", path: "/Gongjiao/74", component: gj74 },

  //导航公交线路122 122-mulu4 122-gongjiao3配置
  { name: "gj122", path: "/Gongjiao/122", component: gj122 },

  //导航公交线路gaofengzhuanxian165 gaofengzhuanxian165-mulu4 gaofengzhuanxian165-gongjiao3配置
  { name: "gaofengzhuanxian165", path: "/Gongjiao/gaofengzhuanxian165", component: gaofengzhuanxian165 },

  //导航公交线路gaokuaibashi29 gaokuaibashi29-mulu4 gaokuaibashi29-gongjiao3配置
  { name: "gaokuaibashi29", path: "/Gongjiao/gaokuaibashi29", component: gaokuaibashi29 },

  //导航公交所有线路 zhishengjichang-mulu4 zhishengjichang-gongjiao3配置
  { name: "zhishengjichang", path: "/Gongjiao/zhishengjichang", component: zhishengjichang },

  //导航公交所有线路 gj1-mulu4 gj1-gongjiao3配置
  { name: "gj1", path: "/Gongjiao/1", component: gj1 },

    //导航公交所有线路 gj2-mulu4 gj2-gongjiao3配置
    { name: "gj2", path: "/Gongjiao/2", component: gj2 },

    //导航公交所有线路 gj3-mulu4 gj3-gongjiao3配置
    { name: "gj3", path: "/Gongjiao/3", component: gj3 },

    //导航公交所有线路 gj4-mulu4 gj4-gongjiao3配置
    { name: "gj4", path: "/Gongjiao/4", component: gj4 },

    //导航公交所有线路 gj5-mulu4 gj5-gongjiao3配置
    { name: "gj5", path: "/Gongjiao/5", component: gj5 },

    //导航公交所有线路 gj7-mulu4 gj7-gongjiao3配置
    { name: "gj7", path: "/Gongjiao/7", component: gj7 },

    //导航公交所有线路 gj8-mulu4 gj8-gongjiao3配置
    { name: "gj8", path: "/Gongjiao/8", component: gj8 },

    //导航公交所有线路 gj10-mulu4 gj10-gongjiao3配置
    { name: "gj10", path: "/Gongjiao/10", component: gj10 },

    //导航公交所有线路 gj11-mulu4 gj11-gongjiao3配置
    { name: "gj11", path: "/Gongjiao/11", component: gj11 },

    //导航公交所有线路 gj12-mulu4 gj12-gongjiao3配置
    { name: "gj12", path: "/Gongjiao/12", component: gj12 },

    //导航公交所有线路 gj13-mulu4 gj13-gongjiao3配置
    { name: "gj13", path: "/Gongjiao/13", component: gj13 },

    //gj14-gongjiao3配置
    { name: "gj14", path: "/Gongjiao/14", component: gj14 },

    //gj17-gongjiao3配置
    { name: "gj17", path: "/Gongjiao/17", component: gj17 },

    //gj18-gongjiao3配置
    { name: "gj18", path: "/Gongjiao/18", component: gj18 },

    //gj19-gongjiao3配置
    { name: "gj19", path: "/Gongjiao/19", component: gj19 },

    //gj21-gongjiao3配置
    { name: "gj21", path: "/Gongjiao/21", component: gj21 },

    //gj22-gongjiao3配置
    { name: "gj22", path: "/Gongjiao/22", component: gj22 },

    //gj23-gongjiao3配置
    { name: "gj23", path: "/Gongjiao/23", component: gj23 },

    //gj26-gongjiao3配置
    { name: "gj26", path: "/Gongjiao/26", component: gj26 },

    //gj27-gongjiao3配置
    { name: "gj27", path: "/Gongjiao/27", component: gj27 },

    //gj29-gongjiao3配置
    { name: "gj29", path: "/Gongjiao/29", component: gj29 },

    //gj34-gongjiao3配置
    { name: "gj34", path: "/Gongjiao/34", component: gj34 },

    //gj37-gongjiao3配置
    { name: "gj37", path: "/Gongjiao/37", component: gj37 },

    //gj38-gongjiao3配置
    { name: "gj38", path: "/Gongjiao/38", component: gj38 },

    //gj41-gongjiao3配置
    { name: "gj41", path: "/Gongjiao/41", component: gj41 },

    //gj42-gongjiao3配置
    { name: "gj42", path: "/Gongjiao/42", component: gj42 },
    
    //gj43-gongjiao3配置
    { name: "gj43", path: "/Gongjiao/43", component: gj43 },

    //gj44-gongjiao3配置
    { name: "gj44", path: "/Gongjiao/44", component: gj44 },

    //gj49-gongjiao3配置
    { name: "gj49", path: "/Gongjiao/49", component: gj49 },

    //gj52-gongjiao3配置
    { name: "gj52", path: "/Gongjiao/52", component: gj52 },

    //gj57-gongjiao3配置
    { name: "gj57", path: "/Gongjiao/57", component: gj57 },

     //gj58-gongjiao3配置
     { name: "gj58", path: "/Gongjiao/58", component: gj58 },

    //gj60-gongjiao3配置
     { name: "gj60", path: "/Gongjiao/60", component: gj60 },

    //gj61-gongjiao3配置
     { name: "gj61", path: "/Gongjiao/61", component: gj61 },

    //gj62-gongjiao3配置
     { name: "gj62", path: "/Gongjiao/62", component: gj62 },

    //gj63-gongjiao3配置
     { name: "gj63", path: "/Gongjiao/63", component: gj63 },

    //gj64-gongjiao3配置
     { name: "gj64", path: "/Gongjiao/64", component: gj64 },

    //gj66-gongjiao3配置
     { name: "gj66", path: "/Gongjiao/66", component: gj66 },

    //gj67-gongjiao3配置
     { name: "gj67", path: "/Gongjiao/67", component: gj67 },

    //gj68-gongjiao3配置
     { name: "gj68", path: "/Gongjiao/68", component: gj68 },

    //gj69-gongjiao3配置
     { name: "gj69", path: "/Gongjiao/69", component: gj69 },

    //gj71-gongjiao3配置
    { name: "gj71", path: "/Gongjiao/71", component: gj71 },

    //gj72-gongjiao3配置
    { name: "gj72", path: "/Gongjiao/72", component: gj72 },

    //gj73-gongjiao3配置
    { name: "gj73", path: "/Gongjiao/73", component: gj73 },

    //gj75-gongjiao3配置
    { name: "gj75", path: "/Gongjiao/75", component: gj75 },




        //  // 以下代码暂时停用，等以后需要用到，才启用。#gongjiao
    //   // 所有公交线路站点配置 x路站点 x-gongjiao4配置 
    //   // 公交线路单个站点配置代码模板 { name: "xxx", path: "/Gongjiao/x/xxx", component: xxx },
    //   //e3路站点 e3-gongjiao4配置
          
    //   //e3路站点 e3-gongjiao4配置 公交线路单个站点配置代码模板 { name: "", path: "/Gongjiao/e3/", component:  },
    //   { name: "guangmingzhenmeizongzhan", path: "/Gongjiao/e3/guangmingzhenmeizongzhan", component: guangmingzhenmeizongzhan },  //1
    //   { name: "zhongshanqiyuanhuanchengzhan", path: "/Gongjiao/e3/zhongshanqiyuanhuanchengzhan", component: zhongshanqiyuanhuanchengzhan },  //2
    //   { name: "zhenmeilukou", path: "/Gongjiao/e3/zhenmeilukou", component: zhenmeilukou },  //3
    //   { name: "zhenmeishichang", path: "/Gongjiao/e3/zhenmeishichang", component: zhenmeishichang },  //4
    //   { name: "loucunxiaoxue", path: "/Gongjiao/e3/loucunxiaoxue", component: loucunxiaoxue },  //5
    //   { name: "xinhupaichusuo", path: "/Gongjiao/e3/xinhupaichusuo", component: xinhupaichusuo },  //6
    //   { name: "guangminghongmuxiaozhen", path: "/Gongjiao/e3/guangminghongmuxiaozhen", component: guangminghongmuxiaozhen },  //7
    //   { name: "yongjingchengxi", path: "/Gongjiao/e3/yongjingchengxi", component: yongjingchengxi },  //8
    //   { name: "honghuazhenminglukou", path: "/Gongjiao/e3/honghuazhenminglukou", component: honghuazhenminglukou },  //9
    //   { name: "guokedayiyuanxiyuanqu2", path: "/Gongjiao/e3/guokedayiyuanxiyuanqu2", component: guokedayiyuanxiyuanqu2 },  //10
    //   { name: "jiangshi", path: "/Gongjiao/e3/jiangshi", component: jiangshi },  //11
    //   { name: "jiangwei", path: "/Gongjiao/e3/jiangwei", component: jiangwei },  //12
    //   { name: "guangmingtangwei", path: "/Gongjiao/e3/guangmingtangwei", component: guangmingtangwei },  //13
    //   { name: "minghugongyuandong", path: "/Gongjiao/e3/minghugongyuandong", component: minghugongyuandong },  //14
    //   { name: "hongfagaoxinchanyeyuan", path: "/Gongjiao/e3/hongfagaoxinchanyeyuan", component: hongfagaoxinchanyeyuan },  //15
    //   { name: "zhishengjichang", path: "/Gongjiao/e3/zhishengjichang", component: zhishengjichang },  //16
    //   { name: "yanxiangkejidasha1", path: "/Gongjiao/e3/yanxiangkejidasha1", component: yanxiangkejidasha1 },  //17
    //   { name: "shenzhendaxue", path: "/Gongjiao/e3/shenzhendaxue", component: shenzhendaxue },  //18
    //   { name: "xieheshenzhenyiyuandong", path: "/Gongjiao/e3/xieheshenzhenyiyuandong", component: xieheshenzhenyiyuandong },  //19
    //   { name: "nanhanggongsi", path: "/Gongjiao/e3/nanhanggongsi", component: nanhanggongsi },  //20
    //   { name: "nanshanpaichusuo", path: "/Gongjiao/e3/nanshanpaichusuo", component: nanshanpaichusuo },  //21
    //   { name: "zhongyoudasha", path: "/Gongjiao/e3/zhongyoudasha", component: zhongyoudasha },  //22
    //   { name: "nanyuancundong", path: "/Gongjiao/e3/nanyuancundong", component: nanyuancundong },  //23
    //   { name: "chengshishanlindong", path: "/Gongjiao/e3/chengshishanlindong", component: chengshishanlindong },  //24
    //   { name: "nanyouxidetiezhan", path: "/Gongjiao/e3/nanyouxidetiezhan", component: nanyouxidetiezhan },  //25
    //   { name: "lixiuwenhuajie", path: "/Gongjiao/e3/lixiuwenhuajie", component: lixiuwenhuajie },  //26
    //   { name: "nanmenyifang", path: "/Gongjiao/e3/nanmenyifang", component: nanmenyifang },  //27
    //   { name: "beishidafuzhong", path: "/Gongjiao/e3/beishidafuzhong", component: beishidafuzhong },  //28
    //   { name: "houhaibinlukou", path: "/Gongjiao/e3/houhaibinlukou", component: houhaibinlukou },  //29
    //   { name: "shenzhenwankouangongjiaoshoumozhan", path: "/Gongjiao/e3/shenzhenwankouangongjiaoshoumozhan", component: shenzhenwankouangongjiaoshoumozhan },  //30

      
      
      //a3路站点 a3-gongjiao4配置
    //a3路站点 a3-gongjiao4配置 公交线路单个站点配置代码模板 { name: "", path: "/Gongjiao/a3/", component:  },

      //m313路站点 m313-gongjiao4配置
    //m313路站点 m313-gongjiao4配置 公交线路单个站点配置代码模板 { name: "xxx", path: "/Gongjiao/m313/xxx", component: xxx },

      //m528路站点 m528-gongjiao4配置 
      //  { name: "xxx", path: "/Gongjiao/m528/xxx", component: xxx },
  
      //m539路站点 m539-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/m539/xxx", component: xxx },
   
      //gj74路站点 gj74-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/74/xxx", component: xxx },
               
      //gj122路站点 gj122-gongjiao4配置 
      //{ name: "xxx", path: "/Gongjiao/122/xxx", component: xxx },
                  
      //gaofengzhuanxian165路站点 gaofengzhuanxian165-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/gaofengzhuanxian165/xxx", component: xxx },
                     
      //gaokuaibashi29路站点 gaokuaibashi29-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/gaokuaibashi29/xxx", component: xxx },

      //gongjiaozhandian站点 gongjiaozhandian-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/gongjiaozhandian/xxx", component: xxx },

      //zhishengjichang站点 zhishengjichang-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/gongjiaozhandian/xxx", component: xxx },

      //gj1站点 gj1-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/1/xxx", component: xxx },

      //gj2站点 gj2-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/2/xxx", component: xxx },


      //gj3站点 gj3-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/3/xxx", component: xxx },

      //gj4站点 gj4-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/4/xxx", component: xxx },

      //gj5站点 gj5-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/5/xxx", component: xxx },

      //gj7站点 gj7-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/7/xxx", component: xxx },

      //gj8站点 gj8-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/8/xxx", component: xxx },

      //gj10站点 gj10-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/10/xxx", component: xxx },

      //gj11站点 gj11-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/11/xxx", component: xxx },

      //gj12站点 gj12-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/12/xxx", component: xxx },

      //gj13站点 gj13-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/13/xxx", component: xxx },

      //gj14-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/14/xxx", component: xxx },

      //gj17-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/17/xxx", component: xxx },

      //gj18-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/18/xxx", component: xxx },

      //gj19-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/19/xxx", component: xxx },

      //gj21-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/21/xxx", component: xxx },

      //gj22-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/22/xxx", component: xxx },

      //gj23-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/23/xxx", component: xxx },

      //gj26-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/26/xxx", component: xxx },

      //gj27-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/27/xxx", component: xxx },

      //gj29-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/29/xxx", component: xxx },

      //gj34-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/34/xxx", component: xxx },

      //gj37-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/37/xxx", component: xxx },

      //gj38-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/38/xxx", component: xxx },

      //gj41-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/41/xxx", component: xxx },

      //gj42-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/42/xxx", component: xxx },

      //gj43-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/43/xxx", component: xxx },

      //gj44-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/44/xxx", component: xxx },

      //gj49-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/49/xxx", component: xxx },

      //gj52-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/52/xxx", component: xxx },

      //gj57-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/57/xxx", component: xxx },

      //gj58-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/58/xxx", component: xxx },

      //gj60-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/60/xxx", component: xxx },

      //gj61-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/61/xxx", component: xxx },

      //gj62-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/62/xxx", component: xxx },

      //gj63-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/63/xxx", component: xxx },

      //gj64-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/64/xxx", component: xxx },

      //gj66-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/66/xxx", component: xxx },

      //gj67-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/67/xxx", component: xxx },

      //gj68-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/68/xxx", component: xxx },

      //gj69-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/69/xxx", component: xxx },

      //gj71-gongjiao4配置 
      // { name: "xxx", path: "/Gongjiao/71/xxx", component: xxx },






  //出租车 #chuzuche
  { name: "Chuzuche", path: "/Chuzuche", component: Chuzuche },

  //高铁 #gaotie
  { name: "Gaotie", path: "/Gaotie", component: Gaotie },

  //机场 #jichang
  { name: "Jichang", path: "/Jichang", component: Jichang },

  //轮船 #lunchuan
  { name: "Lunchuan", path: "/lunchuan", component: Lunchuan },

  //核酸 #hesuan 备用 #beiyong
  // { name: "Hesuan", path: "/Hesuan", component: Hesuan },


        

];
